import { computed as __WEBPACK_EXTERNAL_MODULE__ember_object_60179f9a_computed__ } from "@ember/object";
import { default as __WEBPACK_EXTERNAL_MODULE_discourse_lib_url_7cfbca40_default__ } from "discourse/lib/url";
import { default as __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_default__, i18n as __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__ } from "discourse-i18n";
import { default as __WEBPACK_EXTERNAL_MODULE__components_waze_copy_logs_button_37428dd1_default__ } from "../components/waze-copy-logs-button";
import { withPluginApi as __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__ } from "discourse/lib/plugin-api";
import { default as __WEBPACK_EXTERNAL_MODULE_discourse_components_d_navigation_29e7ebfd_default__ } from "discourse/components/d-navigation";
/******/ var __webpack_modules__ = ({

/***/ 247
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createContextualFragment = void 0;
const html_impl_1 = __webpack_require__(5971);
/** Safely creates a contextualFragment. */
function createContextualFragment(range, html) {
    return range.createContextualFragment((0, html_impl_1.unwrapHtml)(html));
}
exports.createContextualFragment = createContextualFragment;


/***/ },

/***/ 249
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setAction = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * Sets the Action attribute from the given Url.
 */
function setAction(form, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        form.action = sanitizedUrl;
    }
}
exports.setAction = setAction;


/***/ },

/***/ 426
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.register = void 0;
const resource_url_impl_1 = __webpack_require__(8402);
/** Safely registers a service worker by URL */
function register(container, scriptURL, options) {
    return container.register((0, resource_url_impl_1.unwrapResourceUrl)(scriptURL), options);
}
exports.register = register;


/***/ },

/***/ 792
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createInertFragment = void 0;
const range_1 = __webpack_require__(247);
const html_impl_1 = __webpack_require__(5971);
/**
 * Returns a fragment that contains the parsed HTML for `dirtyHtml` without
 * executing any of the potential payload.
 */
function createInertFragment(dirtyHtml) {
    // We create a new document to ensure the nodes stay detached
    const doc = document.implementation.createHTMLDocument('');
    const range = doc.createRange();
    range.selectNode(doc.body);
    // This call is only used to create an inert tree for the sanitizer to
    // further process and is never returned directly to the caller. We can't use
    // a reviewed conversion in order to avoid an import loop.
    const temporarySafeHtml = (0, html_impl_1.createHtmlInternal)(dirtyHtml);
    return (0, range_1.createContextualFragment)(range, temporarySafeHtml);
}
exports.createInertFragment = createInertFragment;


/***/ },

/***/ 832
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setSrc = exports.setTextContent = void 0;
const resource_url_impl_1 = __webpack_require__(8402);
const script_impl_1 = __webpack_require__(7253);
/** Returns CSP nonce, if set for any script tag. */
function getScriptNonceFromWindow(win) {
    var _a;
    const doc = win.document;
    // document.querySelector can be undefined in non-browser environments.
    const script = (_a = doc.querySelector) === null || _a === void 0 ? void 0 : _a.call(doc, 'script[nonce]');
    if (script) {
        // Try to get the nonce from the IDL property first, because browsers that
        // implement additional nonce protection features (currently only Chrome) to
        // prevent nonce stealing via CSS do not expose the nonce via attributes.
        // See https://github.com/whatwg/html/issues/2369
        return script['nonce'] || script.getAttribute('nonce') || '';
    }
    return '';
}
/** Propagates CSP nonce to dynamically created scripts. */
function setNonceForScriptElement(script) {
    const win = script.ownerDocument && script.ownerDocument.defaultView;
    const nonce = getScriptNonceFromWindow(win || window);
    if (nonce) {
        script.setAttribute('nonce', nonce);
    }
}
/** Sets textContent from the given SafeScript. */
function setTextContent(script, v, options) {
    script.textContent = (0, script_impl_1.unwrapScript)(v);
    if (options === null || options === void 0 ? void 0 : options.omitNonce)
        return;
    setNonceForScriptElement(script);
}
exports.setTextContent = setTextContent;
/** Sets the Src attribute using a TrustedResourceUrl */
function setSrc(script, v, options) {
    script.src = (0, resource_url_impl_1.unwrapResourceUrl)(v);
    if (options === null || options === void 0 ? void 0 : options.omitNonce)
        return;
    setNonceForScriptElement(script);
}
exports.setSrc = setSrc;


/***/ },

/***/ 1170
(__unused_webpack_module, exports) {


exports.__esModule = true;
exports.modalStyles = exports.backgroundIframeStyles = void 0;
exports.backgroundIframeStyles = "\n#wz-forms-modal-iframe-container {\n    border: 0;\n    vertical-align: bottom;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n\n    z-index: var(--waze-forms-z-index, 1000);\n}\n\n@media only screen and (max-width: 600px) {\n  #wz-forms-modal-iframe-container {\n    z-index: var(--waze-forms-z-index-small-screen, var(--waze-forms-z-index, 1000));\n  }\n}";
exports.modalStyles = "\nbody {\n  margin: 0;\n  overflow: hidden;\n}\n#wz-forms-modal-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: rgba(0, 0, 0, 0.55);\n}\n\n#wz-forms-modal-container {\n  height: 75%;\n  width: 560px;\n}\n\n#wz-forms-modal-iframe {\n  border: 0;\n  border-radius: 8px;\n  height: 100%;\n  width: 100%;\n  background-color: transparent;\n  box-shadow: 0 0 10px 4px rgba(60, 64, 67, .15);\n}\n\n#wz-forms-modal-copy-to-clipboard-popup {\n  font-family: 'Rubik', sans-serif;\n  font-size: 14px;\n  color: #f2f3f4;\n  padding: 8px 10px;\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 17px;\n  position: fixed;\n  bottom: 5%;\n  left: 50%;\n  opacity: 0;\n  transform: translateX(-50%);\n  transition: opacity 0.3s ease;\n}\n\n@media only screen and (max-width: 600px) {\n  #wz-forms-modal-container {\n    width: 100%;\n    height: calc(100% - var(--header-height-small-screen, 0));\n    margin-top: var(--header-height-small-screen, 0);\n  }\n\n  .wz-forms-modal-container--add-header-offset-small-screen {\n    --header-height-small-screen: 56px;\n  }\n\n  #wz-forms-modal-iframe {\n    border-radius: 0;\n  }\n}\n";


/***/ },

/***/ 1204
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.objectUrlFromScript = exports.appendPathSegment = exports.replaceFragment = exports.appendParams = exports.trustedResourceUrl = void 0;
__webpack_require__(5723);
const resource_url_impl_1 = __webpack_require__(8402);
const script_impl_1 = __webpack_require__(7253);
const string_literal_1 = __webpack_require__(5890);
/**
 * Check whether the base url contains a valid origin,
 *
 * A string for an origin must contain only alphanumeric or any of the
 * following: `-.:`, and must not be an IP address. Remember that, as per the
 * documentation for TrustedResourceUrl, the origin must be trustworthy.
 *
 * @param base The base url that contains an origin.
 */
function hasValidOrigin(base) {
    if (!(/^https:\/\//.test(base) || /^\/\//.test(base))) {
        return false;
    }
    const originStart = base.indexOf('//') + 2;
    const originEnd = base.indexOf('/', originStart);
    // If the base url only contains the prefix (e.g. //), or the slash
    // for the origin is right after the prefix (e.g. ///), the origin is
    // missing.
    if (originEnd <= originStart) {
        throw new Error(`Can't interpolate data in a url's origin, ` +
            `Please make sure to fully specify the origin, terminated with '/'.`);
    }
    const origin = base.substring(originStart, originEnd);
    if (!/^[0-9a-z.:-]+$/i.test(origin)) {
        throw new Error('The origin contains unsupported characters.');
    }
    if (!/^[^:]*(:[0-9]+)?$/i.test(origin)) {
        throw new Error('Invalid port number.');
    }
    if (!/(^|\.)[a-z][^.]*$/i.test(origin)) {
        throw new Error('The top-level domain must start with a letter.');
    }
    return true;
}
/**
 * Check whether the base url contains a valid about url at its beginning.
 *
 * An about url is either exactly 'about:blank' or 'about:blank#<str>' where
 * <str> can be an arbitrary string.
 *
 * @param base The base url.
 */
function isValidAboutUrl(base) {
    if (!/^about:blank/.test(base)) {
        return false;
    }
    if (base !== 'about:blank' && !/^about:blank#/.test(base)) {
        throw new Error('The about url is invalid.');
    }
    return true;
}
/**
 * Check whether the base url contains a valid path start at its beginning.
 *
 * A valid path start is either a '/' or a '/' followed by at least one
 * character that is not '/' or '\'.
 *
 * @param base The base url.
 */
function isValidPathStart(base) {
    if (!/^\//.test(base)) {
        return false;
    }
    if ((base === '/') ||
        (base.length > 1 && base[1] !== '/' && base[1] !== '\\')) {
        return true;
    }
    throw new Error('The path start in the url is invalid.');
}
/**
 * Builds TrustedResourceUrl from a template literal.
 *
 * This factory is a template literal tag function. It should be called with
 * a template literal, with or without embedded expressions. For example,
 *               trustedResourceUrl`//example.com/${bar}`;
 * or
 *               trustedResourceUrl`//example.com`;
 *
 * When this function is called with a template literal without any embedded
 * expressions, the template string may contain anything as the whole URL is
 * a compile-time string constant.
 *
 * When this function is called with a template literal that contains embedded
 * expressions, the template must start with one of the following:
 * - `https://<origin>/`
 * - `//<origin>/`
 * - `/<pathStart>`
 * - `about:blank`
 * - `data:`
 *
 * `<origin>` must contain only alphanumeric or any of the following: `-.:`.
 * Remember that, as per the documentation for TrustedResourceUrl, the origin
 * must be trustworthy. An origin of "example.com" could be set with this
 * method, but would tie the security of your site to the security of
 * example.com. Similarly, formats that potentially cover redirects hosted
 * on a trusted origin are problematic, since that could lead to untrusted
 * origins.
 *
 * `<pathStart>` is either an empty string, or a non empty string that does not
 * start with '/' or '\'.
 * In other words, `/<pathStart>` is either a '/' or a
 * '/' followed by at least one character that is not '/' or '\'.
 *
 * `data:` (data URL) does not allow embedded expressions in the template
 * literal input.
 *
 * All embedded expressions are URL encoded when they are interpolated. Do not
 * embed expressions that are already URL encoded as they will be double encoded
 * by the builder.
 *
 * @param templateObj This contains the literal part of the template literal.
 * @param rest This represents the template's embedded expressions.
 */
function trustedResourceUrl(templateObj, ...rest) {
    // Check if templateObj is actually from a template literal.
    if (false) // removed by dead control flow
{}
    if (rest.length === 0) {
        return (0, resource_url_impl_1.createResourceUrlInternal)(templateObj[0]);
    }
    const base = templateObj[0].toLowerCase();
    if (false) // removed by dead control flow
{}
    let url = templateObj[0];
    for (let i = 0; i < rest.length; i++) {
        url += encodeURIComponent(rest[i]) + templateObj[i + 1];
    }
    return (0, resource_url_impl_1.createResourceUrlInternal)(url);
}
exports.trustedResourceUrl = trustedResourceUrl;
/**
 * Creates a new TrustedResourceUrl with params added to the URL's search
 * parameters.
 *
 * @param params What to add to the URL. Parameters with value `null` or
 * `undefined` are skipped. Both keys and values will be encoded. Do not pass
 * pre-encoded values as this will result them being double encoded. If the
 * value is an array then the same parameter is added for every element in the
 * array.
 */
function appendParams(trustedUrl, params) {
    let url = (0, resource_url_impl_1.unwrapResourceUrl)(trustedUrl).toString();
    if (/#/.test(url)) {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
    let separator = /\?/.test(url) ? '&' : '?';
    // for-of has a big polyfill.
    // tslint:disable-next-line:ban-iterable-foreach
    params.forEach((value, key) => {
        const values = (value instanceof Array) ? value : [value];
        for (let i = 0; i < values.length; i++) {
            const v = values[i];
            if (v === null || v === undefined) {
                continue;
            }
            url += separator + encodeURIComponent(key) + '=' +
                encodeURIComponent(String(v));
            separator = '&';
        }
    });
    return (0, resource_url_impl_1.createResourceUrlInternal)(url);
}
exports.appendParams = appendParams;
const BEFORE_FRAGMENT_REGEXP = /[^#]*/;
/**
 * Creates a new TrustedResourceUrl based on an existing one but with the
 * addition of a fragment (the part after `#`). If the URL already has a
 * fragment, it is replaced with the new one.
 * @param fragment The fragment to add to the URL, verbatim, without the leading
 * `#`. No additional escaping is applied.
 */
function replaceFragment(trustedUrl, fragment) {
    const urlString = (0, resource_url_impl_1.unwrapResourceUrl)(trustedUrl).toString();
    return (0, resource_url_impl_1.createResourceUrlInternal)(BEFORE_FRAGMENT_REGEXP.exec(urlString)[0] + '#' + fragment);
}
exports.replaceFragment = replaceFragment;
/**
 * Creates a new TrustedResourceUrl based on an existing one with a single
 * subpath segment added to the end of the existing path and prior to any query
 * parameters and/or fragments that already exist in the URL.
 * @param pathSegment The singular sub path being added to the URL. Do not pass
 *     a pre-encoded value as this will result in it being double encoded.
 */
function appendPathSegment(trustedUrl, pathSegment) {
    const originalUrl = (0, resource_url_impl_1.unwrapResourceUrl)(trustedUrl).toString();
    const urlSegments = originalUrl.split(/\?|#/);
    const basePath = urlSegments[0];
    const paramVals = /\?/.test(originalUrl) ? urlSegments[1] : undefined;
    const fragVal = /#/.test(originalUrl) ?
        (paramVals ? urlSegments[2] : urlSegments[1]) :
        undefined;
    const pathSeparator = basePath.charAt(basePath.length - 1) === '/' ? '' : '/';
    let url = basePath + pathSeparator + encodeURIComponent(pathSegment);
    if (paramVals !== undefined) {
        url += '?' + paramVals;
    }
    if (fragVal !== undefined) {
        url += '#' + fragVal;
    }
    return (0, resource_url_impl_1.createResourceUrlInternal)(url);
}
exports.appendPathSegment = appendPathSegment;
/**
 * Creates a `TrustedResourceUrl` by generating a `Blob` from a
 * `SafeScript` and then calling `URL.createObjectURL` with that `Blob`.
 *
 * Caller must call `URL.revokeObjectUrl()` on the stringified url to
 * release the underlying `Blob`.
 */
function objectUrlFromScript(safeScript) {
    const scriptContent = (0, script_impl_1.unwrapScript)(safeScript).toString();
    const blob = new Blob([scriptContent], { type: 'text/javascript' });
    return (0, resource_url_impl_1.createResourceUrlInternal)(URL.createObjectURL(blob));
}
exports.objectUrlFromScript = objectUrlFromScript;


/***/ },

/***/ 1205
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setHref = void 0;
__webpack_require__(5723);
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * Sets the Href attribute from the given URL.
 * javascript: and data: URL are blocked as they can lead to XSS and the <use>
 * element only loads resources same-origin.
 */
function setHref(useEl, url) {
    const scheme = (0, url_sanitizer_1.extractScheme)(url);
    if (scheme === 'javascript:' || scheme === 'data:') {
        if (false) // removed by dead control flow
{}
        return;
    }
    // Note that the href property is read-only, so setAttribute must be used.
    useEl.setAttribute('href', url);
}
exports.setHref = setHref;


/***/ },

/***/ 1318
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.restrictivelySanitizeUrl = exports.unwrapUrlOrSanitize = exports.sanitizeJavaScriptUrl = exports.extractScheme = void 0;
/**
 * @fileoverview Provides functions to enforce the SafeUrl contract at the sink
 * level.
 */
__webpack_require__(5723);
/**
 * Extracts the scheme from the given URL. If the URL is relative, https: is
 * assumed.
 * @param url The URL to extract the scheme from.
 * @return the URL scheme.
 */
function extractScheme(url) {
    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    }
    catch (e) {
        // According to https://url.spec.whatwg.org/#constructors, the URL
        // constructor with one parameter throws if `url` is not absolute. In this
        // case, we are sure that no explicit scheme (javascript: ) is set.
        // This can also be a URL parsing error, but in this case the URL won't be
        // run anyway.
        return 'https:';
    }
    return parsedUrl.protocol;
}
exports.extractScheme = extractScheme;
// We can't use an ES6 Set here because gws somehow depends on this code and
// doesn't want to pay the cost of a polyfill.
const ALLOWED_SCHEMES = ['data:', 'http:', 'https:', 'mailto:', 'ftp:'];
/**
 * Checks that the URL scheme is not javascript.
 * The URL parsing relies on the URL API in browsers that support it.
 * @param url The URL to sanitize for a SafeUrl sink.
 * @return undefined if url has a javascript: scheme, the original URL
 *     otherwise.
 */
function sanitizeJavaScriptUrl(url) {
    const parsedScheme = extractScheme(url);
    if (parsedScheme === 'javascript:') {
        if (false) // removed by dead control flow
{}
        return undefined;
    }
    return url;
}
exports.sanitizeJavaScriptUrl = sanitizeJavaScriptUrl;
/**
 * Adapter to sanitize string URLs in DOM sink wrappers.
 * @return undefined if the URL was sanitized.
 */
function unwrapUrlOrSanitize(url) {
    return sanitizeJavaScriptUrl(url);
}
exports.unwrapUrlOrSanitize = unwrapUrlOrSanitize;
/**
 * Sanitizes a URL restrictively.
 * This sanitizer protects against XSS and potentially other uncommon and
 * undesirable schemes that an attacker could use for e.g. phishing (tel:,
 * callto: ssh: etc schemes). This sanitizer is primarily meant to be used by
 * the HTML sanitizer.
 */
function restrictivelySanitizeUrl(url) {
    const parsedScheme = extractScheme(url);
    if (parsedScheme !== undefined &&
        ALLOWED_SCHEMES.indexOf(parsedScheme.toLowerCase()) !== -1) {
        return url;
    }
    return 'about:invalid#zClosurez';
}
exports.restrictivelySanitizeUrl = restrictivelySanitizeUrl;


/***/ },

/***/ 1556
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sanitizeHtmlToFragment = exports.sanitizeHtmlAssertUnchanged = exports.sanitizeHtml = exports.HtmlSanitizerImpl = void 0;
__webpack_require__(5723);
const html_impl_1 = __webpack_require__(5971);
/* g3_import_pure from '../../internals/pure' */
const secrets_1 = __webpack_require__(2022);
const url_sanitizer_1 = __webpack_require__(1318);
const inert_fragment_1 = __webpack_require__(792);
const no_clobber_1 = __webpack_require__(7142);
const default_sanitizer_table_1 = __webpack_require__(2236);
const sanitizer_table_1 = __webpack_require__(7513);
/** Implementation for `HtmlSanitizer` */
class HtmlSanitizerImpl {
    constructor(sanitizerTable, token) {
        this.sanitizerTable = sanitizerTable;
        this.changes = [];
        (0, secrets_1.ensureTokenIsValid)(token);
    }
    sanitizeAssertUnchanged(html) {
        this.changes = [];
        const sanitizedHtml = this.sanitize(html);
        if (this.changes.length !== 0) {
            let message = '';
            if (false) // removed by dead control flow
{}
            throw new Error(message);
        }
        return sanitizedHtml;
    }
    sanitize(html) {
        const fakeRoot = document.createElement('span');
        fakeRoot.appendChild(this.sanitizeToFragment(html));
        // XML serialization is preferred over HTML serialization as it is
        // stricter and makes sure all attributes are properly escaped, avoiding
        // cases where the tree might mutate when parsed again later due to the
        // complexities of the HTML parsing algorithm
        let serializedNewTree = new XMLSerializer().serializeToString(fakeRoot);
        // We remove the outer most element as this is the span node created as
        // the root for the sanitized tree and contains a spurious xmlns attribute
        // from the XML serialization step.
        serializedNewTree = serializedNewTree.slice(serializedNewTree.indexOf('>') + 1, serializedNewTree.lastIndexOf('</'));
        return (0, html_impl_1.createHtmlInternal)(serializedNewTree);
    }
    sanitizeToFragment(html) {
        const dirtyFragment = (0, inert_fragment_1.createInertFragment)(html);
        const treeWalker = document.createTreeWalker(dirtyFragment, 5 /* NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT */, 
        // IE10 and IE11 won't accept a proper `NodeFilter` interface, and
        // expect the filtering function to be passed directly. It seems that
        // other browsers also do not mind getting the function directly. see
        // https://stackoverflow.com/q/38245898
        ((n) => this.nodeFilter(n)), 
        // @ts-ignore: error TS2554: Expected 1-3 arguments, but got 4.
        false);
        // `nextNode` is called so we skip the root `DocumentFragment`.
        let currentNode = treeWalker.nextNode();
        // We create a root element to attach all the children of the body to. We
        // use div as it as a semantic-free, generic container and does not
        // represent anything. This is removed when we serialize the tree back
        // into a string.
        const sanitizedFragment = document.createDocumentFragment();
        let sanitizedParent = sanitizedFragment;
        while (currentNode !== null) {
            let sanitizedNode;
            if ((0, no_clobber_1.isText)(currentNode)) {
                sanitizedNode = this.sanitizeTextNode(currentNode);
            }
            else if ((0, no_clobber_1.isElement)(currentNode)) {
                sanitizedNode = this.sanitizeElementNode(currentNode);
            }
            else {
                let message = '';
                if (false) // removed by dead control flow
{}
                throw new Error(message);
            }
            sanitizedParent.appendChild(sanitizedNode);
            // Advance iterator while keeping track of the sanitized parent for the
            // current node
            currentNode = treeWalker.firstChild();
            if (currentNode) {
                sanitizedParent = sanitizedNode;
            }
            else {
                while (!(currentNode = treeWalker.nextSibling())) {
                    if (!(currentNode = treeWalker.parentNode())) {
                        break;
                    }
                    sanitizedParent = sanitizedParent.parentNode;
                }
            }
        }
        return sanitizedFragment;
    }
    sanitizeTextNode(textNode) {
        return document.createTextNode(textNode.data);
    }
    sanitizeElementNode(elementNode) {
        const elementName = (0, no_clobber_1.getNodeName)(elementNode);
        const newNode = document.createElement(elementName);
        const dirtyAttributes = elementNode.attributes;
        for (const { name, value } of dirtyAttributes) {
            const policy = this.sanitizerTable.getAttributePolicy(name, elementName);
            if (!this.satisfiesAllConditions(policy.conditions, dirtyAttributes)) {
                this.recordChange(`Not all conditions satisfied for attribute: ${name}.`);
                continue;
            }
            switch (policy.policyAction) {
                case sanitizer_table_1.AttributePolicyAction.KEEP:
                    setAttribute(newNode, name, value);
                    break;
                case sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_URL:
                    const sanitizedAttrUrl = (0, url_sanitizer_1.restrictivelySanitizeUrl)(value);
                    if (sanitizedAttrUrl !== value) {
                        this.recordChange(`Url in attribute ${name} was modified during sanitization. Original url:"${value}" was sanitized to: "${sanitizedAttrUrl}"`);
                    }
                    setAttribute(newNode, name, sanitizedAttrUrl);
                    break;
                case sanitizer_table_1.AttributePolicyAction.KEEP_AND_NORMALIZE:
                    // We don't consider changing the case of an attribute value to be a
                    // semantic change
                    setAttribute(newNode, name, value.toLowerCase());
                    break;
                case sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_STYLE:
                    setAttribute(newNode, name, value);
                    break;
                case sanitizer_table_1.AttributePolicyAction.DROP:
                    this.recordChange(`Attribute: ${name} was dropped`);
                    break;
                default:
                    if (false) // removed by dead control flow
{}
            }
        }
        return newNode;
    }
    nodeFilter(node) {
        if ((0, no_clobber_1.isText)(node)) {
            return 1; // NodeFilter.FILTER_ACCEPT
        }
        else if (!(0, no_clobber_1.isElement)(node)) {
            // Getting a node that is neither an `Element` or a `Text` node. This is
            // likely due to something that is not supposed to be an element in user
            // code but recognized as such by the TreeWalker (e.g. a polyfill for
            // other kind of nodes). Since we can't recognize it as an element, we
            // drop the node, but we don't record it as a meaningful change.
            return 2; // NodeFilter.FILTER_REJECT
        }
        const nodeName = (0, no_clobber_1.getNodeName)(node);
        if (nodeName === null) {
            this.recordChange(`Node name was null for node: ${node}`);
            return 2; // NodeFilter.FILTER_REJECT
        }
        if (this.sanitizerTable.isAllowedElement(nodeName)) {
            return 1; // NodeFilter.FILTER_ACCEPT
        }
        this.recordChange(`Element: ${nodeName} was dropped`);
        return 2; // NodeFilter.FILTER_REJECT
    }
    recordChange(errorMessage) {
        if (false) // removed by dead control flow
{}
        else if (this.changes.length === 0) {
            this.changes.push('');
        }
    }
    satisfiesAllConditions(conditions, attrs) {
        var _a;
        if (!conditions) {
            return true;
        }
        for (const [attrName, expectedValues] of conditions) {
            const value = (_a = attrs.getNamedItem(attrName)) === null || _a === void 0 ? void 0 : _a.value;
            if (value && !expectedValues.has(value)) {
                return false;
            }
        }
        return true;
    }
}
exports.HtmlSanitizerImpl = HtmlSanitizerImpl;
/** @noinline Helper to save on codesize. */
function setAttribute(el, name, value) {
    el.setAttribute(name, value);
}
const defaultHtmlSanitizer = 
/* #__PURE__ */ (() => new HtmlSanitizerImpl(default_sanitizer_table_1.defaultSanitizerTable, secrets_1.secretToken))();
/** Sanitizes untrusted html using the default sanitizer configuration. */
function sanitizeHtml(html) {
    return defaultHtmlSanitizer.sanitize(html);
}
exports.sanitizeHtml = sanitizeHtml;
/**
 * Sanitizes untrusted html using the default sanitizer configuration. Throws
 * an error if the html was changed.
 */
function sanitizeHtmlAssertUnchanged(html) {
    return defaultHtmlSanitizer.sanitizeAssertUnchanged(html);
}
exports.sanitizeHtmlAssertUnchanged = sanitizeHtmlAssertUnchanged;
/**
 * Sanitizes untrusted html using the default sanitizer configuration. Throws
 * an error if the html was changed.
 */
function sanitizeHtmlToFragment(html) {
    return defaultHtmlSanitizer.sanitizeToFragment(html);
}
exports.sanitizeHtmlToFragment = sanitizeHtmlToFragment;
function checkExhaustive(value, msg = `unexpected value ${value}!`) {
    throw new Error(msg);
}


/***/ },

/***/ 2022
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ensureTokenIsValid = exports.secretToken = void 0;
__webpack_require__(5723);
/**
 * A secret token that must be passed to safe type constructors. It is only
 * accessible from within safevalues, ensuring that unrestricted safe type
 * creation is only possible within safevalues. In particular, this prevents
 * forgery such as `safeHtmlValue.constructor('javascript:evil')`.
 */
exports.secretToken = {};
/**
 * Asserts that the given token matches the secret safevalues token. An
 * exception is thrown if that is not the case.
 */
function ensureTokenIsValid(token) {
    if (false) // removed by dead control flow
{}
}
exports.ensureTokenIsValid = ensureTokenIsValid;


/***/ },

/***/ 2146
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.safeAttrPrefix = void 0;
__webpack_require__(5723);
const attribute_impl_1 = __webpack_require__(6324);
const string_literal_1 = __webpack_require__(5890);
const sensitive_attributes_1 = __webpack_require__(2747);
/**
 * Creates a SafeAttributePrefix object from a template literal with no
 * interpolations for attributes that share a common prefix guaranteed to be not
 * security sensitive.
 *
 * The template literal is a prefix that makes it obvious this attribute is not
 * security sensitive. If it doesn't, this function will throw.
 */
function safeAttrPrefix(templ) {
    if (false) // removed by dead control flow
{}
    const attrPrefix = templ[0].toLowerCase();
    if (false) // removed by dead control flow
{}
    return (0, attribute_impl_1.createAttributePrefixInternal)(attrPrefix);
}
exports.safeAttrPrefix = safeAttrPrefix;


/***/ },

/***/ 2183
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.globalEval = exports.fetchResourceUrl = void 0;
const script_impl_1 = __webpack_require__(7253);
var fetch_1 = __webpack_require__(3246);
Object.defineProperty(exports, "fetchResourceUrl", ({ enumerable: true, get: function () { return fetch_1.fetchResourceUrl; } }));
/**
 * Evaluates a SafeScript value in the given scope using eval.
 *
 * Strongly consider avoiding this, as eval blocks CSP adoption and does not
 * benefit from compiler optimizations.
 */
function globalEval(win, script) {
    const trustedScript = (0, script_impl_1.unwrapScript)(script);
    let result = win.eval(trustedScript);
    if (result === trustedScript) {
        // https://crbug.com/1024786 manifesting in workers.
        result = win.eval(trustedScript.toString());
    }
    return result;
}
exports.globalEval = globalEval;


/***/ },

/***/ 2236
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultSanitizerTable = void 0;
/* GENERATED CODE, DO NOT MODIFY */
/* g3_import_pure from '../../../internals/pure' */
const sanitizer_table_1 = __webpack_require__(7513);
const ALLOWED_ELEMENTS = [
    'ARTICLE', 'SECTION', 'NAV', 'ASIDE', 'H1', 'H2',
    'H3', 'H4', 'H5', 'H6', 'HEADER', 'FOOTER',
    'ADDRESS', 'P', 'HR', 'PRE', 'BLOCKQUOTE', 'OL',
    'UL', 'LH', 'LI', 'DL', 'DT', 'DD',
    'FIGURE', 'FIGCAPTION', 'MAIN', 'DIV', 'EM', 'STRONG',
    'SMALL', 'S', 'CITE', 'Q', 'DFN', 'ABBR',
    'RUBY', 'RB', 'RT', 'RTC', 'RP', 'DATA',
    'TIME', 'CODE', 'VAR', 'SAMP', 'KBD', 'SUB',
    'SUP', 'I', 'B', 'U', 'MARK', 'BDI',
    'BDO', 'SPAN', 'BR', 'WBR', 'INS', 'DEL',
    'PICTURE', 'PARAM', 'TRACK', 'MAP', 'TABLE', 'CAPTION',
    'COLGROUP', 'COL', 'TBODY', 'THEAD', 'TFOOT', 'TR',
    'TD', 'TH', 'SELECT', 'DATALIST', 'OPTGROUP', 'OPTION',
    'OUTPUT', 'PROGRESS', 'METER', 'FIELDSET', 'LEGEND', 'DETAILS',
    'SUMMARY', 'MENU', 'DIALOG', 'SLOT', 'CANVAS', 'FONT',
    'CENTER', 'ACRONYM', 'BASEFONT', 'BIG', 'DIR', 'HGROUP',
    'STRIKE', 'TT',
];
const ELEMENT_POLICIES = [
    [
        'A', new Map([
            ['href', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_URL }],
        ])
    ],
    [
        'AREA', new Map([
            ['href', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_URL }],
        ])
    ],
    [
        'LINK', new Map([
            [
                'href', {
                    policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_URL,
                    conditions: new Map([[
                            'rel', new Set([
                                'alternate',
                                'author',
                                'bookmark',
                                'canonical',
                                'cite',
                                'help',
                                'icon',
                                'license',
                                'next',
                                'prefetch',
                                'dns-prefetch',
                                'prerender',
                                'preconnect',
                                'preload',
                                'prev',
                                'search',
                                'subresource',
                            ])
                        ]])
                }
            ],
        ])
    ],
    [
        'SOURCE', new Map([
            ['src', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP }],
        ])
    ],
    [
        'IMG', new Map([
            ['src', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP }],
        ])
    ],
    [
        'VIDEO', new Map([
            ['src', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP }],
        ])
    ],
    [
        'AUDIO', new Map([
            ['src', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP }],
        ])
    ],
];
const ALLOWED_GLOBAL_ATTRIBUTES = [
    'title',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-current',
    'aria-disabled',
    'aria-dropeffect',
    'aria-expanded',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-label',
    'aria-level',
    'aria-live',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'alt',
    'align',
    'autocapitalize',
    'autocomplete',
    'autocorrect',
    'autofocus',
    'autoplay',
    'bgcolor',
    'border',
    'cellpadding',
    'cellspacing',
    'checked',
    'color',
    'cols',
    'colspan',
    'controls',
    'datetime',
    'disabled',
    'download',
    'draggable',
    'enctype',
    'face',
    'formenctype',
    'frameborder',
    'height',
    'hreflang',
    'hidden',
    'ismap',
    'label',
    'lang',
    'loop',
    'max',
    'maxlength',
    'media',
    'minlength',
    'min',
    'multiple',
    'muted',
    'nonce',
    'open',
    'placeholder',
    'preload',
    'rel',
    'required',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'spellcheck',
    'start',
    'step',
    'summary',
    'translate',
    'type',
    'valign',
    'value',
    'width',
    'wrap',
    'itemscope',
    'itemtype',
    'itemid',
    'itemprop',
    'itemref',
];
const GLOBAL_ATTRIBUTE_POLICIES = [
    [
        'dir', {
            policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_NORMALIZE,
            conditions: /* #__PURE__ */ (() => {
                return new Map([[
                        'dir', new Set([
                            'auto',
                            'ltr',
                            'rtl',
                        ])
                    ]]);
            })()
        }
    ],
    [
        'async', {
            policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_NORMALIZE,
            conditions: /* #__PURE__ */ (() => {
                return new Map([[
                        'async', new Set([
                            'async',
                        ])
                    ]]);
            })()
        }
    ],
    ['cite', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_URL }],
    [
        'loading', {
            policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_NORMALIZE,
            conditions: /* #__PURE__ */ (() => {
                return new Map([[
                        'loading', new Set([
                            'eager',
                            'lazy',
                        ])
                    ]]);
            })()
        }
    ],
    ['poster', { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_URL }],
    [
        'target', {
            policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_NORMALIZE,
            conditions: /* #__PURE__ */ (() => {
                return new Map([[
                        'target', new Set([
                            '_self',
                            '_blank',
                        ])
                    ]]);
            })()
        }
    ],
];
/**
 * Sanitizer table for the default sanitizer configuration
 *
 */
exports.defaultSanitizerTable = new sanitizer_table_1.SanitizerTable(new Set(ALLOWED_ELEMENTS), new Map(ELEMENT_POLICIES), new Set(ALLOWED_GLOBAL_ATTRIBUTES), new Map(GLOBAL_ATTRIBUTE_POLICIES));


/***/ },

/***/ 2305
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setAttribute = void 0;
__webpack_require__(5723);
const UNSAFE_SVG_ATTRIBUTES = [
    'href',
    'xlink:href',
];
/**
 * Set attribute on SVGElement if the attribute doesn't have security
 * implications. If the attribute can potentially cause XSS, throw an error.
 */
function setAttribute(svg, attr, value) {
    attr = attr.toLowerCase();
    if (UNSAFE_SVG_ATTRIBUTES.indexOf(attr) !== -1 || attr.indexOf('on') === 0) {
        let msg = '';
        if (false) // removed by dead control flow
{}
        throw new Error(msg);
    }
    svg.setAttribute(attr, value);
}
exports.setAttribute = setAttribute;


/***/ },

/***/ 2675
(__unused_webpack_module, exports) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.objectUrlFromSafeSource = void 0;
/**
 * A pattern that matches safe MIME types. Only matches image, video and audio
 * types, with some parameter support (most notably, we haven't implemented the
 * more complex parts like %-encoded characters or non-alphanumerical ones for
 * simplicity's sake). Also, the specs are fairly complex, and they don't
 * necessarily agree with Chrome on some aspects, and so we settled on a subset
 * where the behavior makes sense to all parties involved.
 *
 * The spec is available at https://mimesniff.spec.whatwg.org/ (and see
 * https://tools.ietf.org/html/rfc2397 for data: urls, which override some of
 * it).
 */
function isSafeMimeType(mimeType) {
    const match = mimeType.match(/^([^;]+)(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i);
    return (match === null || match === void 0 ? void 0 : match.length) === 2 &&
        (isSafeImageMimeType(match[1]) || isSafeVideoMimeType(match[1]) ||
            isSafeAudioMimeType(match[1]));
}
function isSafeImageMimeType(mimeType) {
    return /^image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon|heic|heif)$/i.test(mimeType);
}
function isSafeVideoMimeType(mimeType) {
    return /^video\/(?:mpeg|mp4|ogg|webm|x-matroska|quicktime|x-ms-wmv)$/i.test(mimeType);
}
function isSafeAudioMimeType(mimeType) {
    return /^audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)$/i
        .test(mimeType);
}
/**
 * Wraps URL.createObjectURL, checking the safety of the source. For blobs, the
 * function validates that the Blob's type is amongst the safe MIME types, and
 * throws if that's not the case. URL.revokeObjectURL should be called on the
 * returned URL to free the resources.
 */
function objectUrlFromSafeSource(source) {
    // MediaSource support in Safari is limited
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaSource#browser_compatibility
    if (typeof MediaSource !== 'undefined' && source instanceof MediaSource) {
        return URL.createObjectURL(source);
    }
    const blob = source;
    if (!isSafeMimeType(blob.type)) {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
    return URL.createObjectURL(blob);
}
exports.objectUrlFromSafeSource = objectUrlFromSafeSource;


/***/ },

/***/ 2747
(__unused_webpack_module, exports) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SECURITY_SENSITIVE_ATTRIBUTES = void 0;
// AUTOGENERATED. DO NOT EDIT.
/**
 * Security sensitive attribute names that should not be set through
 * `setAttribute` or similar functions.
 */
exports.SECURITY_SENSITIVE_ATTRIBUTES = [
    'src',
    'srcdoc',
    'codebase',
    'data',
    'href',
    'rel',
    'action',
    'formaction',
    'sandbox',
    'cite',
    'poster',
    'icon',
];


/***/ },

/***/ 3246
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchResourceUrl = exports.IncorrectContentTypeError = void 0;
/**
 * @fileoverview
 * Functions which allow fetch() on resourceUrls to be
 * interpreted as SafeHtml or SafeScript.
 */
const html_impl_1 = __webpack_require__(5971);
const resource_url_impl_1 = __webpack_require__(8402);
const script_impl_1 = __webpack_require__(7253);
const style_sheet_impl_1 = __webpack_require__(4455);
/**
 * IncorrectTypeError represents an error that can occur with {@link
 * fetchResourceUrl} when the server responds with a content type that would be
 * unsafe for the type of content requested.
 */
class IncorrectContentTypeError extends Error {
    constructor(url, typeName, contentType) {
        super(`${url} was requested as a ${typeName}, but the response Content-Type, "${contentType} is not appropriate for this type of content.`);
        this.url = url;
        this.typeName = typeName;
        this.contentType = contentType;
    }
}
exports.IncorrectContentTypeError = IncorrectContentTypeError;
/**
 * This causes the compiler to better optimize `createHtmlInternal` calls, where
 * previously it was building and including the whole module without
 * tree-shaking.
 *
 * TODO(b/254093954) find out why this is and remove this workaround.
 */
function privatecreateHtmlInternal(html) {
    return (0, html_impl_1.createHtmlInternal)(html);
}
/**
 * fetches a given {@link TrustedResourceUrl},
 * and returns a value which can be turned into a given safe type.
 */
function fetchResourceUrl(u, init) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch((0, resource_url_impl_1.unwrapResourceUrl)(u).toString(), init);
        /**
         * the content type type of the response, excluding any MIME params
         */
        const mimeType = (_c = (_b = (_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.split(';', 2)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.toLowerCase();
        return {
            html() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (mimeType !== 'text/html') {
                        throw new IncorrectContentTypeError(response.url, 'SafeHtml', 'text/html');
                    }
                    const text = yield response.text();
                    return privatecreateHtmlInternal(text);
                });
            },
            script() {
                return __awaiter(this, void 0, void 0, function* () {
                    // see:
                    // https://html.spec.whatwg.org/multipage/scripting.html#scriptingLanguages
                    if (mimeType !== 'text/javascript' &&
                        mimeType !== 'application/javascript') {
                        throw new IncorrectContentTypeError(response.url, 'SafeScript', 'text/javascript');
                    }
                    const text = yield response.text();
                    return (0, script_impl_1.createScriptInternal)(text);
                });
            },
            styleSheet() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (mimeType !== 'text/css') {
                        throw new IncorrectContentTypeError(response.url, 'SafeStyleSheet', 'text/css');
                    }
                    const text = yield response.text();
                    return (0, style_sheet_impl_1.createStyleSheetInternal)(text);
                });
            }
        };
    });
}
exports.fetchResourceUrl = fetchResourceUrl;


/***/ },

/***/ 3491
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setFormaction = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * Sets the Formaction attribute from the given Url.
 */
function setFormaction(button, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        button.formAction = sanitizedUrl;
    }
}
exports.setFormaction = setFormaction;


/***/ },

/***/ 3679
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.safeScriptWithArgs = exports.valueAsScript = exports.concatScripts = exports.safeScript = void 0;
__webpack_require__(5723);
const script_impl_1 = __webpack_require__(7253);
const string_literal_1 = __webpack_require__(5890);
/**
 * Creates a SafeScript object from a template literal (without any embedded
 * expressions).
 *
 * This function is a template literal tag function. It should be called with
 * a template literal that does not contain any expressions. For example,
 *                           safeScript`foo`;
 *
 * @param templateObj This contains the literal part of the template literal.
 */
function safeScript(templateObj) {
    if (false) // removed by dead control flow
{}
    return (0, script_impl_1.createScriptInternal)(templateObj[0]);
}
exports.safeScript = safeScript;
/** Creates a `SafeScript` value by concatenating multiple `SafeScript`s. */
function concatScripts(scripts) {
    return (0, script_impl_1.createScriptInternal)(scripts.map(script_impl_1.unwrapScript).join(''));
}
exports.concatScripts = concatScripts;
/**
 * Converts a serializable value into JSON that is safe to interpolate into a
 * script context. In particular it escapes < characters so that a value of
 * "</script>" doesn't break out of the context.
 * @param value The value to serialize.
 */
function valueAsScript(value) {
    return (0, script_impl_1.createScriptInternal)(JSON.stringify(value).replace(/</g, '\\u003C'));
}
exports.valueAsScript = valueAsScript;
/**
 * Creates a `SafeScript` object from a template literal (without any embedded
 * expressions) along with additional arguments that the script should have
 * access to. These arguments will be JSON-encoded and passed to the script as
 * a function call.
 * @example
 * ```ts
 * safeScriptWithArgs`function (name, props) {
 *  console.log(name + ' is ' + props.age);
 * }`('Bob', { 'age': 42 })
 * ```
 * would return a `SafeScript` that represents the following code:
 * ```js
 * (function (name, props) {
 *  console.log(name + ' is ' + props.age);
 * })("Bob",{"age":42})
 * ```
 * @note Be careful when passing objects as arguments, as unquoted property
 * names may be changed during compilation.
 * @param templateObj This contains the literal part of the template literal.
 * @param emptyArgs Expressions that evaluate to the empty string to enable
 *     inline comments.
 */
function safeScriptWithArgs(templateObj, ...emptyArgs) {
    if (false) // removed by dead control flow
{}
    return (...argValues) => {
        const values = argValues.map((v) => valueAsScript(v).toString());
        return (0, script_impl_1.createScriptInternal)(`(${templateObj.join('')})(${values.join(',')})`);
    };
}
exports.safeScriptWithArgs = safeScriptWithArgs;


/***/ },

/***/ 4030
(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.WazeForms = exports.ModalCommand = exports.AuthScheme = void 0;
var styles_1 = __webpack_require__(1170);
var cookie_1 = __webpack_require__(6596);
var dom_1 = __webpack_require__(8973);
var safevalues_1 = __webpack_require__(4782);
var AuthCookie;
(function (AuthCookie) {
    AuthCookie["ADS_SESSION"] = "session_jwt";
    AuthCookie["RT_SESSION"] = "_rt_session_cookie";
    AuthCookie["WEB_SESSION"] = "_web_session";
})(AuthCookie || (AuthCookie = {}));
var AuthScheme;
(function (AuthScheme) {
    AuthScheme["SCHEME_UNSPECIFIED"] = "SCHEME_UNSPECIFIED";
    AuthScheme["REALTIME"] = "WRT";
    AuthScheme["ADS"] = "WADS";
})(AuthScheme = exports.AuthScheme || (exports.AuthScheme = {}));
var ModalCommand;
(function (ModalCommand) {
    ModalCommand["POST_SUBMIT"] = "postSubmit";
    ModalCommand["GET_AUTH_PARAMS"] = "getAuthParams";
    ModalCommand["ON_CLOSE"] = "onClose";
    ModalCommand["ON_CANCEL"] = "onCancel";
    ModalCommand["RESIZE_FORM"] = "resizeForm";
    ModalCommand["COPY_TO_CLIPBOARD"] = "copyToClipboardPopup";
})(ModalCommand = exports.ModalCommand || (exports.ModalCommand = {}));
var DEFAULT_FORM_LOCALE = "en";
var DEFAULT_FORM_ID = "default";
var DEFAULT_FORM_CHANNEL = "unknown";
var ELEMENT_ID_PREFIX = "wz-forms-modal";
var MODAL_CONTAINER_ID = "".concat(ELEMENT_ID_PREFIX, "-container");
var MODAL_IFRAME_ID = "".concat(ELEMENT_ID_PREFIX, "-iframe");
var COPY_MESSAGE_POPUP_ID = "".concat(ELEMENT_ID_PREFIX, "-copy-to-clipboard-popup");
var PRODUCTION_ORIGIN = "https://www.waze.com";
var SUPPORTED_ORIGINS = [
    PRODUCTION_ORIGIN,
    "https://www.gcp.wazestg.com",
    "https://beta.waze.com",
];
var IL_ENV_URL_PREFIX = "il-ContactForm";
var ROW_ENV_URL_PREFIX = "row-ContactForm";
var NA_ENV_URL_PREFIX = "na-ContactForm";
var DEFAULT_ENV_URL_PREFIX = "ContactForm";
var ENV_PREFIX = {
    il: IL_ENV_URL_PREFIX,
    na: NA_ENV_URL_PREFIX,
    row: ROW_ENV_URL_PREFIX,
    stg: DEFAULT_ENV_URL_PREFIX
};
var WazeForms = /** @class */ (function () {
    function WazeForms(config) {
        var _this = this;
        var _a, _b, _c;
        this.commands = {};
        this.startForm = function (formData, document) { return __awaiter(_this, void 0, void 0, function () {
            var _a, modalIframe;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.topIframe) {
                            this.dismissForm();
                        }
                        _a = this;
                        return [4 /*yield*/, this.createBackgroundIframe((document || window.document).body)];
                    case 1:
                        _a.topIframe = _d.sent();
                        this.topIframeDoc =
                            this.topIframe.contentDocument || ((_b = this.topIframe.contentWindow) === null || _b === void 0 ? void 0 : _b.document);
                        modalIframe = this.addModalIframe(formData);
                        this.registerCommands(modalIframe);
                        (_c = this.topIframeDoc) === null || _c === void 0 ? void 0 : _c.addEventListener("keydown", this.handleEscapeKey);
                        return [2 /*return*/];
                }
            });
        }); };
        this.dismissForm = function () {
            var _a, _b;
            if (!_this.topIframe) {
                return;
            }
            (_a = _this.topIframeDoc) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", _this.handleEscapeKey);
            (_b = _this.topIframe.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(_this.topIframe);
            _this.topIframe = undefined;
        };
        this.handleEscapeKey = function (e) {
            if (e.keyCode === 27) {
                _this.dismissForm();
            }
        };
        this.registerCommands = function (modalIframe) {
            var _a;
            var formWindow = modalIframe.contentWindow;
            if (!formWindow) {
                throw new Error("Could not inject callbacks to form");
            }
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            _this.registerCommand(ModalCommand.POST_SUBMIT, _this.onSubmit);
            _this.registerCommand(ModalCommand.GET_AUTH_PARAMS, _this.getAuthParams);
            _this.registerCommand(ModalCommand.ON_CLOSE, _this.onClose);
            _this.registerCommand(ModalCommand.ON_CANCEL, _this.onCancel);
            _this.registerCommand(ModalCommand.RESIZE_FORM, _this.resizeForm);
            _this.registerCommand(ModalCommand.COPY_TO_CLIPBOARD, _this.copyToClipboardPopup);
            (_a = _this.topIframe.contentWindow) === null || _a === void 0 ? void 0 : _a.addEventListener("message", function (event) {
                _this.executeCommand(event.data.cmd, event.data.args, event.ports[0]);
            }, false);
        };
        // Popping "copy successful/failed" outside the modal
        this.copyToClipboardPopup = function (popupText) {
            var _a;
            var popUpElement = (_a = _this.topIframeDoc) === null || _a === void 0 ? void 0 : _a.querySelector("#".concat(COPY_MESSAGE_POPUP_ID));
            if (!popUpElement) {
                throw new Error("could not detect copy-to-clipboard helper");
            }
            dom_1.safeElement.setInnerHtml(popUpElement, (0, safevalues_1.sanitizeHtml)(popupText));
            popUpElement.style.opacity = "1";
            setTimeout(function () { return (popUpElement.style.opacity = "0"); }, 1500);
        };
        // Generates an empty IFrame element to separate host site document. All dom manipulation are inside it
        this.createBackgroundIframe = function (docBodyElement) {
            return new Promise(function (resolve) {
                // Create empty iframe to separate docs from calling site
                var containerIFrameEl = docBodyElement.ownerDocument.createElement("iframe");
                containerIFrameEl.id = "".concat(ELEMENT_ID_PREFIX, "-iframe-container");
                containerIFrameEl.style.setProperty("--waze-forms-z-index", _this.zIndex);
                containerIFrameEl.style.setProperty("--waze-forms-z-index-small-screen", _this.zIndexSmallScreen);
                // Adding style of the iframe
                var styleEl = docBodyElement.ownerDocument.createElement("style");
                docBodyElement.ownerDocument.head.appendChild(styleEl);
                styleEl.type = "text/css";
                styleEl.id = "".concat(ELEMENT_ID_PREFIX, "-container-style");
                styleEl.appendChild(docBodyElement.ownerDocument.createTextNode(styles_1.backgroundIframeStyles));
                containerIFrameEl.onload = function () {
                    resolve(containerIFrameEl);
                };
                docBodyElement.appendChild(containerIFrameEl);
            });
        };
        // Generates form iframe + helper elements.
        this.addModalIframe = function (formData) {
            if (!_this.topIframeDoc) {
                throw new Error("no valid iframe doc");
            }
            // Add style for the modal
            var styleEl = _this.topIframeDoc.createElement("style");
            _this.topIframeDoc.head.appendChild(styleEl);
            styleEl.type = "text/css";
            styleEl.appendChild(_this.topIframeDoc.createTextNode(styles_1.modalStyles));
            // Background shade
            var backgroundEl = _this.topIframeDoc.createElement("div");
            backgroundEl.id = "".concat(ELEMENT_ID_PREFIX, "-background");
            _this.topIframeDoc.body.appendChild(backgroundEl);
            // Modal's body
            var formContainerEl = _this.topIframeDoc.createElement("div");
            formContainerEl.id = MODAL_CONTAINER_ID;
            formContainerEl.classList.toggle("wz-forms-modal-container--add-header-offset-small-screen", _this.addHeaderOffsetSmallScreen);
            backgroundEl.appendChild(formContainerEl);
            // Modal's content
            var formIFrameEl = _this.topIframeDoc.createElement("iframe");
            formIFrameEl.id = MODAL_IFRAME_ID;
            formIFrameEl.src = _this.formUrl(formData).href;
            formContainerEl.appendChild(formIFrameEl);
            // Helper element for copy-to-clipboard interaction
            var popUpMessageEl = _this.topIframeDoc.createElement("div");
            popUpMessageEl.id = COPY_MESSAGE_POPUP_ID;
            _this.topIframeDoc.body.appendChild(popUpMessageEl);
            return formIFrameEl;
        };
        this.zIndex = (_a = config.zIndex) !== null && _a !== void 0 ? _a : "";
        this.zIndexSmallScreen = (_b = config.zIndexSmallScreen) !== null && _b !== void 0 ? _b : "";
        this.addHeaderOffsetSmallScreen =
            (_c = config.addHeaderOffsetSmallScreen) !== null && _c !== void 0 ? _c : false;
        this.cancelCallback = config.cancelCallback;
        this.submitCallback = config.submitCallback;
        this.closeCallback = config.closeCallback;
        this.env = config.env;
        this.authParams = config.authParams;
    }
    WazeForms.prototype.registerCommand = function (cmd, fn) {
        this.commands[cmd] = fn.bind(this);
    };
    WazeForms.prototype.executeCommand = function (cmd, args, port) {
        var _a;
        if (args === void 0) { args = []; }
        if (!cmd || !this.commands[cmd]) {
            console.error("command ".concat(cmd, " not found"));
            port === null || port === void 0 ? void 0 : port.postMessage({ error: new Error("".concat(cmd, " not found")) });
            return;
        }
        try {
            var result = (_a = this.commands)[cmd].apply(_a, args);
            if (result instanceof Promise) {
                result
                    .then(function (r) { return port === null || port === void 0 ? void 0 : port.postMessage({ result: r }); })["catch"](function (e) {
                    port === null || port === void 0 ? void 0 : port.postMessage({ error: e });
                    console.error("Failed to execute ".concat(cmd), e);
                });
            }
            else {
                port === null || port === void 0 ? void 0 : port.postMessage({ result: result });
            }
        }
        catch (e) {
            console.error("Failed to execute ".concat(cmd), e);
            port === null || port === void 0 ? void 0 : port.postMessage({ error: e });
        }
    };
    WazeForms.prototype.getAuthParams = function () {
        if (this.authParams && this.authParams.scheme && this.authParams.token) {
            return this.authParams;
        }
        var cookies = (0, cookie_1.parse)(window.document.cookie);
        if (cookies[AuthCookie.RT_SESSION]) {
            return {
                scheme: AuthScheme.REALTIME,
                token: cookies[AuthCookie.RT_SESSION]
            };
        }
        if (cookies[AuthCookie.ADS_SESSION]) {
            return {
                scheme: AuthScheme.ADS,
                token: cookies[AuthCookie.ADS_SESSION]
            };
        }
        return null;
    };
    WazeForms.prototype.onSubmit = function (result) {
        if (this.submitCallback) {
            try {
                this.submitCallback(result);
            }
            catch (e) {
                console.error("could not perform submit callback", result, e);
            }
        }
    };
    WazeForms.prototype.onClose = function (args) {
        if (this.closeCallback) {
            try {
                this.closeCallback(args);
            }
            catch (e) {
                console.error("could not perform close callback", args, e);
            }
        }
        this.dismissForm();
    };
    WazeForms.prototype.onCancel = function () {
        if (this.cancelCallback) {
            try {
                this.cancelCallback();
            }
            catch (e) {
                console.error("could not perform cancel callback", e);
            }
        }
        this.dismissForm();
    };
    // Used while changing from form to confirmation state
    WazeForms.prototype.resizeForm = function (height, width) {
        var _a;
        if (!this.topIframe) {
            throw new Error("no current open form");
        }
        var containerEl = (_a = this.topIframeDoc) === null || _a === void 0 ? void 0 : _a.querySelector("#".concat(MODAL_CONTAINER_ID));
        containerEl.style.height = "".concat(height, "px");
        containerEl.style.width = "".concat(width, "px");
    };
    WazeForms.prototype.formOrigin = function () {
        if (SUPPORTED_ORIGINS.includes(window.location.origin)) {
            return window.location.origin;
        }
        return PRODUCTION_ORIGIN;
    };
    WazeForms.prototype.formUrl = function (formData) {
        var origin = this.formOrigin();
        var prefix = this.env ? ENV_PREFIX[this.env] : DEFAULT_ENV_URL_PREFIX;
        var path = "form/".concat(formData.locale || DEFAULT_FORM_LOCALE, "/").concat(formData.id || DEFAULT_FORM_ID);
        var url = new URL("".concat(origin, "/").concat(prefix, "/").concat(path));
        url.searchParams.append("modalDisplay", "1");
        url.searchParams.append("channel", formData.channel || DEFAULT_FORM_CHANNEL);
        for (var property in formData.additionalParams) {
            if (Object.prototype.hasOwnProperty.call(formData.additionalParams, property)) {
                url.searchParams.append(property, formData.additionalParams[property]);
            }
        }
        return url;
    };
    return WazeForms;
}());
exports.WazeForms = WazeForms;


/***/ },

/***/ 4094
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseFromString = exports.parseXml = exports.parseHtml = void 0;
__webpack_require__(5723);
const html_impl_1 = __webpack_require__(5971);
/** Safely parses a string using the HTML parser. */
function parseHtml(parser, html) {
    return parseFromString(parser, html, 'text/html');
}
exports.parseHtml = parseHtml;
/**
 * Safely parses a string using the XML parser. If the XML document is found to
 * contain any elements from the HTML or SVG namespaces, an error is thrown for
 * security reasons.
 */
function parseXml(parser, xml) {
    const doc = parseFromString(parser, (0, html_impl_1.createHtmlInternal)(xml), 'text/xml');
    const iterator = document.createNodeIterator(doc, NodeFilter.SHOW_ALL, null, 
    // @ts-ignore: error TS2554: Expected 1-3 arguments, but got 4.
    false);
    let currentNode;
    while ((currentNode = iterator.nextNode())) {
        if (currentNode instanceof HTMLElement ||
            currentNode instanceof SVGElement) {
            let message = 'unsafe XML';
            if (false) // removed by dead control flow
{}
            throw new Error(message);
        }
    }
    return doc;
}
exports.parseXml = parseXml;
/** Safely parses a string using the HTML or XML parser. */
function parseFromString(parser, content, contentType) {
    return parser.parseFromString((0, html_impl_1.unwrapHtml)(content), contentType);
}
exports.parseFromString = parseFromString;


/***/ },

/***/ 4315
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setFormaction = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * Sets the Formaction attribute from the given Url.
 */
function setFormaction(input, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        input.formAction = sanitizedUrl;
    }
}
exports.setFormaction = setFormaction;


/***/ },

/***/ 4455
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unwrapStyleSheet = exports.isStyleSheet = exports.createStyleSheetInternal = exports.SafeStyleSheet = void 0;
__webpack_require__(5723);
const secrets_1 = __webpack_require__(2022);
/**
 * A complete CSS style sheet, safe to use in style contexts in an HTML document
 * or DOM APIs.
 */
class SafeStyleSheet {
}
exports.SafeStyleSheet = SafeStyleSheet;
/** Implementation for `SafeStyleSheet` */
class StyleSheetImpl extends SafeStyleSheet {
    constructor(styleSheet, token) {
        super();
        (0, secrets_1.ensureTokenIsValid)(token);
        this.privateDoNotAccessOrElseWrappedStyleSheet = styleSheet;
    }
    toString() {
        return this.privateDoNotAccessOrElseWrappedStyleSheet;
    }
}
/**
 * Builds a new `SafeStyleSheet` from the given string, without enforcing
 * safety guarantees. This shouldn't be exposed to application developers, and
 * must only be used as a step towards safe builders or safe constants.
 */
function createStyleSheetInternal(styleSheet) {
    return new StyleSheetImpl(styleSheet, secrets_1.secretToken);
}
exports.createStyleSheetInternal = createStyleSheetInternal;
/**
 * Checks if the given value is a `SafeStyleSheet` instance.
 */
function isStyleSheet(value) {
    return value instanceof StyleSheetImpl;
}
exports.isStyleSheet = isStyleSheet;
/**
 * Returns the string value of the passed `SafeStyleSheet` object while
 * ensuring it has the correct type.
 */
function unwrapStyleSheet(value) {
    if (value instanceof StyleSheetImpl) {
        return value.privateDoNotAccessOrElseWrappedStyleSheet;
    }
    else {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
}
exports.unwrapStyleSheet = unwrapStyleSheet;


/***/ },

/***/ 4782
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unwrapStyleSheet = exports.SafeStyleSheet = exports.isStyleSheet = exports.unwrapScript = exports.SafeScript = exports.isScript = exports.EMPTY_SCRIPT = exports.unwrapResourceUrl = exports.TrustedResourceUrl = exports.isResourceUrl = exports.unwrapHtml = exports.SafeHtml = exports.isHtml = exports.EMPTY_HTML = exports.unwrapAttributePrefix = exports.SafeAttributePrefix = exports.safeStyleSheet = exports.concatStyleSheets = exports.valueAsScript = exports.safeScriptWithArgs = exports.safeScript = exports.concatScripts = exports.trustedResourceUrl = exports.replaceFragment = exports.objectUrlFromScript = exports.appendPathSegment = exports.appendParams = exports.HtmlSanitizerBuilder = exports.sanitizeHtmlToFragment = exports.sanitizeHtmlAssertUnchanged = exports.sanitizeHtml = exports.scriptUrlToHtml = exports.scriptToHtml = exports.joinHtmls = exports.htmlEscape = exports.concatHtmls = exports.safeAttrPrefix = void 0;
/** Safe builders */
var attribute_builders_1 = __webpack_require__(2146);
Object.defineProperty(exports, "safeAttrPrefix", ({ enumerable: true, get: function () { return attribute_builders_1.safeAttrPrefix; } }));
var html_builders_1 = __webpack_require__(9905);
Object.defineProperty(exports, "concatHtmls", ({ enumerable: true, get: function () { return html_builders_1.concatHtmls; } }));
Object.defineProperty(exports, "htmlEscape", ({ enumerable: true, get: function () { return html_builders_1.htmlEscape; } }));
Object.defineProperty(exports, "joinHtmls", ({ enumerable: true, get: function () { return html_builders_1.joinHtmls; } }));
Object.defineProperty(exports, "scriptToHtml", ({ enumerable: true, get: function () { return html_builders_1.scriptToHtml; } }));
Object.defineProperty(exports, "scriptUrlToHtml", ({ enumerable: true, get: function () { return html_builders_1.scriptUrlToHtml; } }));
var html_sanitizer_1 = __webpack_require__(1556);
Object.defineProperty(exports, "sanitizeHtml", ({ enumerable: true, get: function () { return html_sanitizer_1.sanitizeHtml; } }));
Object.defineProperty(exports, "sanitizeHtmlAssertUnchanged", ({ enumerable: true, get: function () { return html_sanitizer_1.sanitizeHtmlAssertUnchanged; } }));
Object.defineProperty(exports, "sanitizeHtmlToFragment", ({ enumerable: true, get: function () { return html_sanitizer_1.sanitizeHtmlToFragment; } }));
var html_sanitizer_builder_1 = __webpack_require__(8100);
Object.defineProperty(exports, "HtmlSanitizerBuilder", ({ enumerable: true, get: function () { return html_sanitizer_builder_1.HtmlSanitizerBuilder; } }));
var resource_url_builders_1 = __webpack_require__(1204);
Object.defineProperty(exports, "appendParams", ({ enumerable: true, get: function () { return resource_url_builders_1.appendParams; } }));
Object.defineProperty(exports, "appendPathSegment", ({ enumerable: true, get: function () { return resource_url_builders_1.appendPathSegment; } }));
Object.defineProperty(exports, "objectUrlFromScript", ({ enumerable: true, get: function () { return resource_url_builders_1.objectUrlFromScript; } }));
Object.defineProperty(exports, "replaceFragment", ({ enumerable: true, get: function () { return resource_url_builders_1.replaceFragment; } }));
Object.defineProperty(exports, "trustedResourceUrl", ({ enumerable: true, get: function () { return resource_url_builders_1.trustedResourceUrl; } }));
var script_builders_1 = __webpack_require__(3679);
Object.defineProperty(exports, "concatScripts", ({ enumerable: true, get: function () { return script_builders_1.concatScripts; } }));
Object.defineProperty(exports, "safeScript", ({ enumerable: true, get: function () { return script_builders_1.safeScript; } }));
Object.defineProperty(exports, "safeScriptWithArgs", ({ enumerable: true, get: function () { return script_builders_1.safeScriptWithArgs; } }));
Object.defineProperty(exports, "valueAsScript", ({ enumerable: true, get: function () { return script_builders_1.valueAsScript; } }));
var style_sheet_builders_1 = __webpack_require__(8213);
Object.defineProperty(exports, "concatStyleSheets", ({ enumerable: true, get: function () { return style_sheet_builders_1.concatStyleSheets; } }));
Object.defineProperty(exports, "safeStyleSheet", ({ enumerable: true, get: function () { return style_sheet_builders_1.safeStyleSheet; } }));
/** Types, constants and unwrappers */
var attribute_impl_1 = __webpack_require__(6324);
Object.defineProperty(exports, "SafeAttributePrefix", ({ enumerable: true, get: function () { return attribute_impl_1.SafeAttributePrefix; } }));
Object.defineProperty(exports, "unwrapAttributePrefix", ({ enumerable: true, get: function () { return attribute_impl_1.unwrapAttributePrefix; } }));
var html_impl_1 = __webpack_require__(5971);
Object.defineProperty(exports, "EMPTY_HTML", ({ enumerable: true, get: function () { return html_impl_1.EMPTY_HTML; } }));
Object.defineProperty(exports, "isHtml", ({ enumerable: true, get: function () { return html_impl_1.isHtml; } }));
Object.defineProperty(exports, "SafeHtml", ({ enumerable: true, get: function () { return html_impl_1.SafeHtml; } }));
Object.defineProperty(exports, "unwrapHtml", ({ enumerable: true, get: function () { return html_impl_1.unwrapHtml; } }));
var resource_url_impl_1 = __webpack_require__(8402);
Object.defineProperty(exports, "isResourceUrl", ({ enumerable: true, get: function () { return resource_url_impl_1.isResourceUrl; } }));
Object.defineProperty(exports, "TrustedResourceUrl", ({ enumerable: true, get: function () { return resource_url_impl_1.TrustedResourceUrl; } }));
Object.defineProperty(exports, "unwrapResourceUrl", ({ enumerable: true, get: function () { return resource_url_impl_1.unwrapResourceUrl; } }));
var script_impl_1 = __webpack_require__(7253);
Object.defineProperty(exports, "EMPTY_SCRIPT", ({ enumerable: true, get: function () { return script_impl_1.EMPTY_SCRIPT; } }));
Object.defineProperty(exports, "isScript", ({ enumerable: true, get: function () { return script_impl_1.isScript; } }));
Object.defineProperty(exports, "SafeScript", ({ enumerable: true, get: function () { return script_impl_1.SafeScript; } }));
Object.defineProperty(exports, "unwrapScript", ({ enumerable: true, get: function () { return script_impl_1.unwrapScript; } }));
var style_sheet_impl_1 = __webpack_require__(4455);
Object.defineProperty(exports, "isStyleSheet", ({ enumerable: true, get: function () { return style_sheet_impl_1.isStyleSheet; } }));
Object.defineProperty(exports, "SafeStyleSheet", ({ enumerable: true, get: function () { return style_sheet_impl_1.SafeStyleSheet; } }));
Object.defineProperty(exports, "unwrapStyleSheet", ({ enumerable: true, get: function () { return style_sheet_impl_1.unwrapStyleSheet; } }));


/***/ },

/***/ 5000
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.open = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * open calls {@link Window.open} on the given {@link Window}, given a
 * target {@link Url}.
 */
function open(win, url, target, features) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        return win.open(sanitizedUrl, target, features);
    }
    return null;
}
exports.open = open;


/***/ },

/***/ 5398
(__unused_webpack_module, exports) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TEST_ONLY = exports.getTrustedTypesPolicy = exports.getTrustedTypes = void 0;
/**
 * The name of the Trusted Types policy used by TS safevalues, or empty
 * to disable Trusted Types. This duplicates the 'google#safe', but
 * can be overridden in tests.
 */
let trustedTypesPolicyName = 'google#safe';
/** Helper to retrieve the value of `window.trustedTypes`. */
function trustedTypes() {
    if (typeof window !== 'undefined') {
        return window.trustedTypes;
    }
    return undefined;
}
/**
 * Returns window.trustedTypes if Trusted Types are enabled and supported, or
 * null otherwise.
 */
function getTrustedTypes() {
    var _a;
    return (trustedTypesPolicyName !== '') ? ((_a = trustedTypes()) !== null && _a !== void 0 ? _a : null) : null;
}
exports.getTrustedTypes = getTrustedTypes;
/**
 * The Trusted Types policy used by TS safevalues, or null if Trusted Types
 * are not enabled/supported, or undefined if the policy has not been created
 * yet.
 */
let trustedTypesPolicy;
/**
 * Returns the Trusted Types policy used by TS safevalues, or null if Trusted
 * Types are not enabled/supported. The first call to this function will
 * create the policy.
 */
function getTrustedTypesPolicy() {
    var _a, _b;
    if (trustedTypesPolicy === undefined) {
        try {
            trustedTypesPolicy =
                (_b = (_a = getTrustedTypes()) === null || _a === void 0 ? void 0 : _a.createPolicy(trustedTypesPolicyName, {
                    createHTML: (s) => s,
                    createScript: (s) => s,
                    createScriptURL: (s) => s
                })) !== null && _b !== void 0 ? _b : null;
        }
        catch (_c) {
            // In Chromium versions before 81, trustedTypes.createPolicy throws if
            // called with a name that is already registered, even if no CSP is set.
            // Until users have largely migrated to 81 or above, catch the error not
            // to break the applications functionally. In such case, the code will
            // fall back to using regular Safe Types.
            trustedTypesPolicy = null;
        }
    }
    return trustedTypesPolicy;
}
exports.getTrustedTypesPolicy = getTrustedTypesPolicy;
/** Helpers for tests. */
exports.TEST_ONLY = {
    resetDefaults() {
        trustedTypesPolicy = undefined;
        trustedTypesPolicyName = 'google#safe';
    },
    setTrustedTypesPolicyName(name) {
        trustedTypesPolicyName = name;
    },
};


/***/ },

/***/ 5494
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setTextContent = void 0;
const style_sheet_impl_1 = __webpack_require__(4455);
/** Safe setters for `HTMLStyleElement`s. */
function setTextContent(elem, safeStyleSheet) {
    elem.textContent = (0, style_sheet_impl_1.unwrapStyleSheet)(safeStyleSheet);
}
exports.setTextContent = setTextContent;


/***/ },

/***/ 5498
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.importScripts = exports.createShared = exports.create = void 0;
const resource_url_impl_1 = __webpack_require__(8402);
/**
 * Safely creates a Web Worker.
 *
 * Example usage:
 *   const trustedResourceUrl = trustedResourceUrl`/safe_script.js`;
 *   safedom.safeWorker.create(trustedResourceUrl);
 * which is a safe alternative to
 *   new Worker(url);
 * The latter can result in loading untrusted code.
 */
function create(url, options) {
    return new Worker((0, resource_url_impl_1.unwrapResourceUrl)(url), options);
}
exports.create = create;
/** Safely creates a shared Web Worker. */
function createShared(url, options) {
    return new SharedWorker((0, resource_url_impl_1.unwrapResourceUrl)(url), options);
}
exports.createShared = createShared;
/** Safely calls importScripts */
function importScripts(scope, ...urls) {
    scope.importScripts(...urls.map(url => (0, resource_url_impl_1.unwrapResourceUrl)(url)));
}
exports.importScripts = importScripts;


/***/ },

/***/ 5723
() {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Ensure process.env.NODE_ENV is set even when not running under Webpack or
 * Node. Terser will strip this out of production binaries.
 */
/*#__PURE__*/ (() => {
    if (typeof process === 'undefined') {
        window.process = { env: { NODE_ENV: 'development' } };
    }
})();


/***/ },

/***/ 5890
(__unused_webpack_module, exports) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assertIsTemplateObject = void 0;
/**
 * An object of type TemplateStringsArray represents the literal part(s) of a
 * template literal. This function checks if a TemplateStringsArray object is
 * actually from a template literal.
 *
 * @param templateObj This contains the literal part of the template literal.
 * @param numExprs The number of embedded expressions
 */
function assertIsTemplateObject(templateObj, numExprs) {
    if (!isTemplateObject(templateObj) || (numExprs + 1) !== templateObj.length) {
        throw new TypeError(`
    ############################## ERROR ##############################

    It looks like you are trying to call a template tag function (fn\`...\`)
    using the normal function syntax (fn(...)), which is not supported.

    The functions in the safevalues library are not designed to be called
    like normal functions, and doing so invalidates the security guarantees
    that safevalues provides.

    If you are stuck and not sure how to proceed, please reach out to us
    instead through:
     - https://github.com/google/safevalues/issues

    ############################## ERROR ##############################`);
    }
}
exports.assertIsTemplateObject = assertIsTemplateObject;
/** Checks if `templateObj` and its raw property are frozen. */
function checkFrozen(templateObj) {
    return Object.isFrozen(templateObj) && Object.isFrozen(templateObj.raw);
}
/**
 * Checks if a function containing a tagged template expression is transpiled.
 */
function checkTranspiled(fn) {
    return fn.toString().indexOf('`') === -1;
}
/**
 * This value tells us if the code is transpiled, in which case we don't
 * check certain things that transpilers typically don't support. The
 * transpilation turns it into a function call that takes an array.
 */
const isTranspiled = checkTranspiled(tag => tag ``) ||
    checkTranspiled(tag => tag `\0`) || checkTranspiled(tag => tag `\n`) ||
    checkTranspiled(tag => tag `\u0000`);
/**
 * This value tells us if `TemplateStringsArray` are typically frozen in the
 * current environment.
 */
const frozenTSA = checkFrozen `` && checkFrozen `\0` && checkFrozen `\n` && checkFrozen `\u0000`;
/** Polyfill of https://github.com/tc39/proposal-array-is-template-object */
function isTemplateObject(templateObj) {
    /*
     * ############################## WARNING ##############################
     *
     * If you are reading this code to understand how to create a value
     * that satifsies this check, STOP and read this paragraph.
     *
     * This function is there to ensure that our tagged template functions are
     * always called using the tag syntax fn`...`, rather than the normal
     * function syntax fn(...). Bypassing this check invalidates the guarantees
     * that safevalues provides and will result in security issues in your code.
     *
     * If you are stuck and not sure how to proceed, please reach out to us
     * instead through:
     *  - https://github.com/google/safevalues/issues
     *
     * ############################## WARNING ##############################
     */
    if (!Array.isArray(templateObj) || !Array.isArray(templateObj.raw)) {
        return false;
    }
    if (templateObj.length !== templateObj.raw.length) {
        return false;
    }
    if (!isTranspiled && templateObj === templateObj.raw) {
        // Sometimes transpilers use the same array to save on codesize if the
        // template has no special characters that would cause the values in each
        // array to be different.
        return false;
    }
    if ((!isTranspiled || frozenTSA) && !checkFrozen(templateObj)) {
        // Transpilers typically don't freeze `TemplateStringsArray` objects, but we
        // expect that if they did, they would do it consistently, so we also
        // dynamically check if they do.
        return false;
    }
    return true;
}


/***/ },

/***/ 5971
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unwrapHtml = exports.isHtml = exports.EMPTY_HTML = exports.createHtmlInternal = exports.SafeHtml = void 0;
__webpack_require__(5723);
const secrets_1 = __webpack_require__(2022);
const trusted_types_1 = __webpack_require__(5398);
/**
 * Runtime implementation of `TrustedHTML` in browsers that don't support it.
 */
class HtmlImpl {
    constructor(html, token) {
        (0, secrets_1.ensureTokenIsValid)(token);
        this.privateDoNotAccessOrElseWrappedHtml = html;
    }
    toString() {
        return this.privateDoNotAccessOrElseWrappedHtml.toString();
    }
}
function createTrustedHtmlOrPolyfill(html, trusted) {
    return (trusted !== null && trusted !== void 0 ? trusted : new HtmlImpl(html, secrets_1.secretToken));
}
const GlobalTrustedHTML = (typeof window !== 'undefined') ? window.TrustedHTML : undefined;
/**
 * Also exports the constructor so that instanceof checks work.
 */
exports.SafeHtml = (GlobalTrustedHTML !== null && GlobalTrustedHTML !== void 0 ? GlobalTrustedHTML : HtmlImpl);
/**
 * Builds a new `SafeHtml` from the given string, without enforcing safety
 * guarantees. It may cause side effects by creating a Trusted Types policy.
 * This shouldn't be exposed to application developers, and must only be used as
 * a step towards safe builders or safe constants.
 */
function createHtmlInternal(html) {
    var _a;
    /** @noinline */
    const noinlineHtml = html;
    return createTrustedHtmlOrPolyfill(noinlineHtml, (_a = (0, trusted_types_1.getTrustedTypesPolicy)()) === null || _a === void 0 ? void 0 : _a.createHTML(noinlineHtml));
}
exports.createHtmlInternal = createHtmlInternal;
/**
 * An empty `SafeHtml` constant.
 * Unlike the function above, using this will not create a policy.
 */
exports.EMPTY_HTML = 
/* #__PURE__ */ (() => { var _a; return createTrustedHtmlOrPolyfill('', (_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.emptyHTML); })();
/**
 * Checks if the given value is a `SafeHtml` instance.
 */
function isHtml(value) {
    var _a;
    return ((_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.isHTML(value)) || value instanceof HtmlImpl;
}
exports.isHtml = isHtml;
/**
 * Returns the value of the passed `SafeHtml` object while ensuring it
 * has the correct type.
 *
 * Returns a native `TrustedHTML` or a string if Trusted Types are disabled.
 */
function unwrapHtml(value) {
    var _a;
    if ((_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.isHTML(value)) {
        return value;
    }
    else if (value instanceof HtmlImpl) {
        return value.privateDoNotAccessOrElseWrappedHtml;
    }
    else {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
}
exports.unwrapHtml = unwrapHtml;


/***/ },

/***/ 6324
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unwrapAttributePrefix = exports.createAttributePrefixInternal = exports.SafeAttributePrefix = void 0;
__webpack_require__(5723);
const secrets_1 = __webpack_require__(2022);
/** A prefix with which an attribute is safe to set using plain strings. */
class SafeAttributePrefix {
}
exports.SafeAttributePrefix = SafeAttributePrefix;
/** Implementation for `SafeAttributePrefix` */
class AttributePrefixImpl extends SafeAttributePrefix {
    constructor(attrPrefix, token) {
        super();
        (0, secrets_1.ensureTokenIsValid)(token);
        this.privateDoNotAccessOrElseWrappedAttrPrefix = attrPrefix;
    }
    toString() {
        return this.privateDoNotAccessOrElseWrappedAttrPrefix;
    }
}
/**
 * Builds a new `SafeAttribute` from the given string, without enforcing
 * safety guarantees. This shouldn't be exposed to application developers, and
 * must only be used as a step towards safe builders or safe constants.
 */
function createAttributePrefixInternal(attrPrefix) {
    return new AttributePrefixImpl(attrPrefix, secrets_1.secretToken);
}
exports.createAttributePrefixInternal = createAttributePrefixInternal;
/**
 * Returns the string value of the passed `SafeAttributePrefix` object while
 * ensuring it has the correct type.
 */
function unwrapAttributePrefix(value) {
    if (value instanceof AttributePrefixImpl) {
        return value.privateDoNotAccessOrElseWrappedAttrPrefix;
    }
    else {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
}
exports.unwrapAttributePrefix = unwrapAttributePrefix;


/***/ },

/***/ 6596
(__unused_webpack_module, exports) {

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ },

/***/ 6647
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setSrcdoc = exports.setSrc = void 0;
/**
 * @fileoverview Safe iframe helpers and go/intents-for-iframes-for-closure
 */
const html_impl_1 = __webpack_require__(5971);
const resource_url_impl_1 = __webpack_require__(8402);
/** Sets the Src attribute using a TrustedResourceUrl */
function setSrc(iframe, v) {
    iframe.src = (0, resource_url_impl_1.unwrapResourceUrl)(v).toString();
}
exports.setSrc = setSrc;
/** Sets the Srcdoc attribute using a SafeHtml */
function setSrcdoc(iframe, v) {
    iframe.srcdoc = (0, html_impl_1.unwrapHtml)(v);
}
exports.setSrcdoc = setSrcdoc;


/***/ },

/***/ 6895
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setHrefAndRel = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
const resource_url_impl_1 = __webpack_require__(8402);
const SAFE_URL_REL_VALUES = [
    'alternate',
    'author',
    'bookmark',
    'canonical',
    'cite',
    'help',
    'icon',
    'license',
    'next',
    'prefetch',
    'dns-prefetch',
    'prerender',
    'preconnect',
    'preload',
    'prev',
    'search',
    'subresource',
];
function setHrefAndRel(link, url, rel) {
    if ((0, resource_url_impl_1.isResourceUrl)(url)) {
        link.href = (0, resource_url_impl_1.unwrapResourceUrl)(url).toString();
    }
    else {
        if (SAFE_URL_REL_VALUES.indexOf(rel) === -1) {
            throw new Error(`TrustedResourceUrl href attribute required with rel="${rel}"`);
        }
        const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
        if (sanitizedUrl === undefined) {
            return;
        }
        link.href = sanitizedUrl;
    }
    link.rel = rel;
}
exports.setHrefAndRel = setHrefAndRel;


/***/ },

/***/ 7142
(__unused_webpack_module, exports) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isElement = exports.isText = exports.getNodeName = void 0;
/**
 * Library that provides safe getters for different node properties and
 * checks for clobbering.
 */
/** Gets a reasonable nodeName, even for clobbered nodes. */
function getNodeName(node) {
    const nodeName = node.nodeName;
    // If the property is clobbered, assume it is an `HTMLFormElement`.
    return (typeof nodeName === 'string') ? nodeName : 'FORM';
}
exports.getNodeName = getNodeName;
/** Returns true if the object passed is a Text node. */
function isText(node) {
    // The property cannot get clobbered on Text nodes.
    return node.nodeType === 3; // Node.TEXT_NODE
}
exports.isText = isText;
/** Returns true if the object passed is an Element node. */
function isElement(node) {
    const nodeType = node.nodeType;
    // If the property is clobbered, we can assume it is an `HTMLFormElement`, and
    // thus an `Element`.
    return (nodeType === 1 /* Node.ELEMENT_NODE */) ||
        (typeof nodeType !== 'number');
}
exports.isElement = isElement;


/***/ },

/***/ 7253
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unwrapScript = exports.isScript = exports.EMPTY_SCRIPT = exports.createScriptInternal = exports.SafeScript = void 0;
__webpack_require__(5723);
const secrets_1 = __webpack_require__(2022);
const trusted_types_1 = __webpack_require__(5398);
/**
 * Runtime implementation of `TrustedScript` in browswers that don't support it.
 * script element.
 */
class ScriptImpl {
    constructor(script, token) {
        (0, secrets_1.ensureTokenIsValid)(token);
        this.privateDoNotAccessOrElseWrappedScript = script;
    }
    toString() {
        return this.privateDoNotAccessOrElseWrappedScript.toString();
    }
}
function createTrustedScriptOrPolyfill(script, trusted) {
    return (trusted !== null && trusted !== void 0 ? trusted : new ScriptImpl(script, secrets_1.secretToken));
}
const GlobalTrustedScript = (typeof window !== 'undefined') ? window.TrustedScript : undefined;
/**
 * Also exports the constructor so that instanceof checks work.
 */
exports.SafeScript = (GlobalTrustedScript !== null && GlobalTrustedScript !== void 0 ? GlobalTrustedScript : ScriptImpl);
/**
 * Builds a new `SafeScript` from the given string, without enforcing
 * safety guarantees. It may cause side effects by creating a Trusted Types
 * policy. This shouldn't be exposed to application developers, and must only be
 * used as a step towards safe builders or safe constants.
 */
function createScriptInternal(script) {
    var _a;
    /** @noinline */
    const noinlineScript = script;
    return createTrustedScriptOrPolyfill(noinlineScript, (_a = (0, trusted_types_1.getTrustedTypesPolicy)()) === null || _a === void 0 ? void 0 : _a.createScript(noinlineScript));
}
exports.createScriptInternal = createScriptInternal;
/**
 * An empty `SafeScript` constant.
 * Unlike the functions above, using this will not create a policy.
 */
exports.EMPTY_SCRIPT = 
/* #__PURE__ */ (() => {
    var _a;
    return createTrustedScriptOrPolyfill('', (_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.emptyScript);
})();
/**
 * Checks if the given value is a `SafeScript` instance.
 */
function isScript(value) {
    var _a;
    return ((_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.isScript(value)) || value instanceof ScriptImpl;
}
exports.isScript = isScript;
/**
 * Returns the value of the passed `SafeScript` object while ensuring it
 * has the correct type.
 *
 * Returns a native `TrustedScript` or a string if Trusted Types are disabled.
 */
function unwrapScript(value) {
    var _a;
    if ((_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.isScript(value)) {
        return value;
    }
    else if (value instanceof ScriptImpl) {
        return value.privateDoNotAccessOrElseWrappedScript;
    }
    else {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
}
exports.unwrapScript = unwrapScript;


/***/ },

/***/ 7513
(__unused_webpack_module, exports) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isCustomElement = exports.AttributePolicyAction = exports.SanitizerTable = void 0;
/** Class for holding element and attribute policies used for sanitization. */
class SanitizerTable {
    constructor(allowedElements, elementPolicies, allowedGlobalAttributes, globalAttributePolicies, globallyAllowedAttributePrefixes) {
        this.allowedElements = allowedElements;
        this.elementPolicies = elementPolicies;
        this.allowedGlobalAttributes = allowedGlobalAttributes;
        this.globalAttributePolicies = globalAttributePolicies;
        this.globallyAllowedAttributePrefixes = globallyAllowedAttributePrefixes;
    }
    isAllowedElement(elementName) {
        // Note: `HTMLFormElement`s are always dropped, supporting them is very
        // costly because of the DOM clobberring they can cause. The additional code
        // size required to properly work around DOM clobberring issues is large and
        // shouldn't be put on every user of the sanitizer. Thoroughly review
        // b/210975025 and the CLs linked there before you start allowing form
        // elements.
        return elementName !== 'FORM' &&
            (this.allowedElements.has(elementName) ||
                this.elementPolicies.has(elementName));
    }
    getAttributePolicy(attributeName, elementName) {
        const elementPolicy = this.elementPolicies.get(elementName);
        if (elementPolicy === null || elementPolicy === void 0 ? void 0 : elementPolicy.has(attributeName)) {
            return elementPolicy.get(attributeName);
        }
        if (this.allowedGlobalAttributes.has(attributeName)) {
            return { policyAction: AttributePolicyAction.KEEP };
        }
        const globalPolicy = this.globalAttributePolicies.get(attributeName);
        if (globalPolicy) {
            return globalPolicy;
        }
        if (this.globallyAllowedAttributePrefixes &&
            [...this.globallyAllowedAttributePrefixes].some((prefix) => attributeName.indexOf(prefix) === 0)) {
            return { policyAction: AttributePolicyAction.KEEP };
        }
        return { policyAction: AttributePolicyAction.DROP };
    }
}
exports.SanitizerTable = SanitizerTable;
/**
 * Values derived from
 * https://godoc.corp.google.com/pkg/google3/third_party/safehtml/sanitizer/policy#AttributePolicy
 */
var AttributePolicyAction;
(function (AttributePolicyAction) {
    AttributePolicyAction[AttributePolicyAction["DROP"] = 0] = "DROP";
    AttributePolicyAction[AttributePolicyAction["KEEP"] = 1] = "KEEP";
    AttributePolicyAction[AttributePolicyAction["KEEP_AND_SANITIZE_URL"] = 2] = "KEEP_AND_SANITIZE_URL";
    AttributePolicyAction[AttributePolicyAction["KEEP_AND_NORMALIZE"] = 3] = "KEEP_AND_NORMALIZE";
    AttributePolicyAction[AttributePolicyAction["KEEP_AND_SANITIZE_STYLE"] = 4] = "KEEP_AND_SANITIZE_STYLE";
})(AttributePolicyAction = exports.AttributePolicyAction || (exports.AttributePolicyAction = {}));
// From the spec:
// https://html.spec.whatwg.org/multipage/custom-elements.html#prod-potentialcustomelementname:~:text=name%20must%20not%20be%20any%20of%20the%20following%3A
const FORBIDDEN_CUSTOM_ELEMENT_NAMES = new Set([
    'ANNOTATION-XML',
    'COLOR-PROFILE',
    'FONT-FACE',
    'FONT-FACE-SRC',
    'FONT-FACE-URI',
    'FONT-FACE-FORMAT',
    'FONT-FACE-NAME',
    'MISSING-GLYPH',
]);
/**
 * Helper for checking if an element tag is a custom element.
 */
function isCustomElement(tag) {
    return !FORBIDDEN_CUSTOM_ELEMENT_NAMES.has(tag.toUpperCase()) &&
        /^[a-z][-_.a-z0-9]*-[-_.a-z0-9]*$/i.test(tag);
}
exports.isCustomElement = isCustomElement;


/***/ },

/***/ 7705
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.execCommandInsertHtml = exports.execCommand = exports.write = void 0;
const html_impl_1 = __webpack_require__(5971);
/**
 * write safely calls {@link Document.write} on the given {@link Document} with
 * the given {@link SafeHtml}.
 */
function write(doc, text) {
    doc.write((0, html_impl_1.unwrapHtml)(text));
}
exports.write = write;
/**
 * Safely calls {@link Document.execCommand}. When command is insertHtml, a
 * SafeHtml must be passed in as value.
 */
function execCommand(doc, command, value) {
    const commandString = String(command);
    let valueArgument = value;
    if (commandString.toLowerCase() === 'inserthtml') {
        valueArgument = (0, html_impl_1.unwrapHtml)(value);
    }
    return doc.execCommand(commandString, /* showUi= */ false, valueArgument);
}
exports.execCommand = execCommand;
/**
 * Safely calls {@link Document.execCommand}('insertHtml').
 * @deprecated Use safeDocument.execCommand.
 */
function execCommandInsertHtml(doc, html) {
    return doc.execCommand('insertHTML', /* showUi= */ false, (0, html_impl_1.unwrapHtml)(html));
}
exports.execCommandInsertHtml = execCommandInsertHtml;


/***/ },

/***/ 7882
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setHref = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * Sets the Href attribute from the given Url.
 */
function setHref(anchor, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        anchor.href = sanitizedUrl;
    }
}
exports.setHref = setHref;


/***/ },

/***/ 8100
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HtmlSanitizerBuilder = void 0;
const secrets_1 = __webpack_require__(2022);
const html_sanitizer_1 = __webpack_require__(1556);
const default_sanitizer_table_1 = __webpack_require__(2236);
const sanitizer_table_1 = __webpack_require__(7513);
/** This class allows modifications to the default sanitizer configuration. */
class HtmlSanitizerBuilder {
    constructor() {
        // To denote if the builder has called build() and therefore should make no
        // further changes to the sanitizer table.
        this.calledBuild = false;
        this.sanitizerTable = default_sanitizer_table_1.defaultSanitizerTable;
    }
    /** Builder option to restrict allowed elements to a smaller subset. */
    onlyAllowElements(elementSet) {
        const allowedElements = new Set();
        const allowedElementPolicies = new Map();
        for (let element of elementSet) {
            element = element.toUpperCase();
            if (!this.sanitizerTable.isAllowedElement(element)) {
                throw new Error(`Element: ${element}, is not allowed by html5_contract.textpb`);
            }
            const elementPolicy = this.sanitizerTable.elementPolicies.get(element);
            if (elementPolicy !== undefined) {
                allowedElementPolicies.set(element, elementPolicy);
            }
            else {
                allowedElements.add(element);
            }
        }
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(allowedElements, allowedElementPolicies, this.sanitizerTable.allowedGlobalAttributes, this.sanitizerTable.globalAttributePolicies);
        return this;
    }
    /**
     * Builder option to allow a set of custom elements. Must be called either
     * without or after `onlyAllowElements` - will be overwritten otherwise.
     * Custom elements must contain a dash.
     */
    allowCustomElement(element, allowedAttributes) {
        const allowedElements = new Set(this.sanitizerTable.allowedElements);
        const allowedElementPolicies = new Map(this.sanitizerTable.elementPolicies);
        element = element.toUpperCase();
        if (!(0, sanitizer_table_1.isCustomElement)(element)) {
            throw new Error(`Element: ${element} is not a custom element`);
        }
        if (allowedAttributes) {
            const elementPolicy = new Map();
            for (const attribute of allowedAttributes) {
                elementPolicy.set(attribute, { policyAction: sanitizer_table_1.AttributePolicyAction.KEEP });
            }
            allowedElementPolicies.set(element, elementPolicy);
        }
        else {
            allowedElements.add(element);
        }
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(allowedElements, allowedElementPolicies, this.sanitizerTable.allowedGlobalAttributes, this.sanitizerTable.globalAttributePolicies);
        return this;
    }
    /**
     * Builder option to restrict allowed attributes to a smaller subset.
     *
     * If the attribute isn't currently allowed then it won't be added.
     */
    onlyAllowAttributes(attributeSet) {
        const allowedGlobalAttributes = new Set();
        const globalAttributePolicies = new Map();
        const elementPolicies = new Map();
        for (const attribute of attributeSet) {
            if (this.sanitizerTable.allowedGlobalAttributes.has(attribute)) {
                allowedGlobalAttributes.add(attribute);
            }
            if (this.sanitizerTable.globalAttributePolicies.has(attribute)) {
                globalAttributePolicies.set(attribute, this.sanitizerTable.globalAttributePolicies.get(attribute));
            }
        }
        for (const [elementName, originalElementPolicy] of this.sanitizerTable
            .elementPolicies.entries()) {
            const newElementPolicy = new Map();
            for (const [attribute, attributePolicy] of originalElementPolicy
                .entries()) {
                if (attributeSet.has(attribute)) {
                    newElementPolicy.set(attribute, attributePolicy);
                }
            }
            elementPolicies.set(elementName, newElementPolicy);
        }
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(this.sanitizerTable.allowedElements, elementPolicies, allowedGlobalAttributes, globalAttributePolicies);
        return this;
    }
    /**
     * Allows the set of data attributes passed.
     *
     * These values must be prefixed with "data-"
     *
     * If called with onlyAllowElements or onlyAllowAttributes, those methods must
     * be called first.
     */
    allowDataAttributes(attributes) {
        const allowedGlobalAttributes = new Set(this.sanitizerTable.allowedGlobalAttributes);
        for (const attribute of attributes) {
            if (attribute.indexOf('data-') !== 0) {
                throw new Error(`data attribute: ${attribute} does not begin with the prefix "data-"`);
            }
            allowedGlobalAttributes.add(attribute);
        }
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(this.sanitizerTable.allowedElements, this.sanitizerTable.elementPolicies, allowedGlobalAttributes, this.sanitizerTable.globalAttributePolicies);
        return this;
    }
    /**
     * Preserves style attributes. Note that the sanitizer won't parse and
     * sanitize the values but keep them as they are. In particular this means
     * that the code will be able to call functions that could do undesirable
     * things (e.g. `url` to trigger a network request), as well as any custom
     * properties or functions defined by the application.
     */
    allowStyleAttributes() {
        const globalAttributePolicies = new Map(this.sanitizerTable.globalAttributePolicies);
        globalAttributePolicies.set('style', {
            policyAction: sanitizer_table_1.AttributePolicyAction.KEEP_AND_SANITIZE_STYLE,
        });
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(this.sanitizerTable.allowedElements, this.sanitizerTable.elementPolicies, this.sanitizerTable.allowedGlobalAttributes, globalAttributePolicies);
        return this;
    }
    /**
     * Preserves the class attribute on all elements. This means contents can
     * adopt CSS styles from other page elements and possibly mask themselves as
     * legitimate UI elements, which can lead to phishing.
     */
    allowClassAttributes() {
        const allowedGlobalAttributes = new Set(this.sanitizerTable.allowedGlobalAttributes);
        allowedGlobalAttributes.add('class');
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(this.sanitizerTable.allowedElements, this.sanitizerTable.elementPolicies, allowedGlobalAttributes, this.sanitizerTable.globalAttributePolicies);
        return this;
    }
    /**
     * Preserves id attributes. This carries moderate risk as it allows an
     * element to override other elements with the same ID.
     */
    allowIdAttributes() {
        const allowedGlobalAttributes = new Set(this.sanitizerTable.allowedGlobalAttributes);
        allowedGlobalAttributes.add('id');
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(this.sanitizerTable.allowedElements, this.sanitizerTable.elementPolicies, allowedGlobalAttributes, this.sanitizerTable.globalAttributePolicies);
        return this;
    }
    /**
     * Preserves (some) attributes that reference existing ids. This carries a
     * moderate security risk, because sanitized content can create semantic
     * associations with existing elements in the page, regardless of the layout.
     * This could be used to override the label associated with a form input by a
     * screen reader, and facilitate phishing.
     */
    allowIdReferenceAttributes() {
        const allowedGlobalAttributes = new Set(this.sanitizerTable.allowedGlobalAttributes);
        // TODO(b/190693339): Generate this subtable from the contract.
        allowedGlobalAttributes.add('aria-activedescendant')
            .add('aria-controls')
            .add('aria-labelledby')
            .add('aria-owns')
            .add('for')
            .add('list');
        this.sanitizerTable = new sanitizer_table_1.SanitizerTable(this.sanitizerTable.allowedElements, this.sanitizerTable.elementPolicies, allowedGlobalAttributes, this.sanitizerTable.globalAttributePolicies);
        return this;
    }
    build() {
        if (this.calledBuild) {
            throw new Error('this sanitizer has already called build');
        }
        this.calledBuild = true;
        return new html_sanitizer_1.HtmlSanitizerImpl(this.sanitizerTable, secrets_1.secretToken);
    }
}
exports.HtmlSanitizerBuilder = HtmlSanitizerBuilder;


/***/ },

/***/ 8135
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setPrefixedAttribute = exports.buildPrefixedAttributeSetter = exports.insertAdjacentHtml = exports.setOuterHtml = exports.setInnerHtml = void 0;
/**
 * @fileoverview This contains safe wrappers for properties that aren't specific
 * to one kind of HTMLElement (like innerHTML), plus other setters and functions
 * that are not tied to elements (like location.href or Worker constructor).
 */
__webpack_require__(5723);
const attribute_impl_1 = __webpack_require__(6324);
const html_impl_1 = __webpack_require__(5971);
/**
 * Safely set {@link Element.innerHTML} on a given ShadowRoot or Element which
 * may not be a `<script>` element or a `<style>` element.
 */
function setInnerHtml(elOrRoot, v) {
    if (isElement(elOrRoot)) {
        throwIfScriptOrStyle(elOrRoot);
    }
    elOrRoot.innerHTML = (0, html_impl_1.unwrapHtml)(v);
}
exports.setInnerHtml = setInnerHtml;
/**
 * Safely set {@link Element.outerHTML} for the given Element.
 */
function setOuterHtml(e, v) {
    const parent = e.parentElement;
    if (parent !== null) {
        throwIfScriptOrStyle(parent);
    }
    e.outerHTML = (0, html_impl_1.unwrapHtml)(v);
}
exports.setOuterHtml = setOuterHtml;
/**
 * Safely call {@link Element.insertAdjacentHTML} for the given Element.
 */
function insertAdjacentHtml(element, position, v) {
    const tagContext = (position === 'beforebegin' || position === 'afterend') ?
        element.parentElement :
        element;
    if (tagContext !== null) {
        throwIfScriptOrStyle(tagContext);
    }
    element.insertAdjacentHTML(position, (0, html_impl_1.unwrapHtml)(v));
}
exports.insertAdjacentHtml = insertAdjacentHtml;
/**
 * Given a set of known-to-be-safe prefixes (e.g., "data-", "aria-", "js"),
 * return a setter function that allows you to set attributes on an element,
 * as long as the names of the attributes to be set has one of the prefixes.
 *
 * The returned setter ensures that setting any dangerous attribute, e.g.,
 * "src", "href" will cause an exception. This is intended to be used as the
 * safe alterantive of `Element#setAttribute`, when applications need to set
 * attributes that do not have security implications and do not have a
 * corresponding DOM property.
 */
function buildPrefixedAttributeSetter(prefix, ...otherPrefixes) {
    const prefixes = [prefix, ...otherPrefixes];
    return (e, attr, value) => {
        setPrefixedAttribute(prefixes, e, attr, value);
    };
}
exports.buildPrefixedAttributeSetter = buildPrefixedAttributeSetter;
/**
 * The safe alternative to Element#setAttribute. The function takes a list of
 * `SafeAttributePrefix`, making developer intention explicit. The attribute
 * to be set must has one of the safe prefixes, otherwise the function throws
 * an Error.
 */
function setPrefixedAttribute(attrPrefixes, e, attr, value) {
    if (attrPrefixes.length === 0) {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
    const prefixes = attrPrefixes.map(s => (0, attribute_impl_1.unwrapAttributePrefix)(s));
    const attrLower = attr.toLowerCase();
    if (prefixes.every(p => attrLower.indexOf(p) !== 0)) {
        throw new Error(`Attribute "${attr}" does not match any of the allowed prefixes.`);
    }
    e.setAttribute(attr, value);
}
exports.setPrefixedAttribute = setPrefixedAttribute;
function throwIfScriptOrStyle(element) {
    let message = '';
    const tagName = element.tagName;
    if (tagName === 'SCRIPT' || tagName === 'STYLE') {
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
}
function isElement(elOrRoot) {
    return elOrRoot.nodeType === 1; // Node.ELEMENT_NODE
}


/***/ },

/***/ 8213
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.concatStyleSheets = exports.safeStyleSheet = void 0;
__webpack_require__(5723);
const string_literal_1 = __webpack_require__(5890);
const style_sheet_impl_1 = __webpack_require__(4455);
/**
 * Creates a SafeStyleSheet object from a template literal (without any
 * embedded expressions).
 *
 * This function is a template literal tag function. It should be called with
 * a template literal that does not contain any expressions. For example,
 *                         safeStyleSheet`foo`;
 * The argument must not have any < or > characters in it. This is so that
 * SafeStyleSheet's contract is preserved, allowing the SafeStyleSheet to
 * correctly be interpreted as a sequence of CSS declarations and without
 * affecting the syntactic structure of any surrounding CSS and HTML.
 *
 * @param templateObj This contains the literal part of the template literal.
 */
function safeStyleSheet(templateObj) {
    if (false) // removed by dead control flow
{}
    const styleSheet = templateObj[0];
    if (false) // removed by dead control flow
{}
    return (0, style_sheet_impl_1.createStyleSheetInternal)(styleSheet);
}
exports.safeStyleSheet = safeStyleSheet;
/**
 * Creates a `SafeStyleSheet` value by concatenating multiple
 * `SafeStyleSheet`s.
 */
function concatStyleSheets(sheets) {
    return (0, style_sheet_impl_1.createStyleSheetInternal)(sheets.map(style_sheet_impl_1.unwrapStyleSheet).join(''));
}
exports.concatStyleSheets = concatStyleSheets;


/***/ },

/***/ 8218
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setHref = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * Sets the Href attribute from the given Url.
 */
function setHref(area, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        area.href = sanitizedUrl;
    }
}
exports.setHref = setHref;


/***/ },

/***/ 8402
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.unwrapResourceUrl = exports.isResourceUrl = exports.createResourceUrlInternal = exports.TrustedResourceUrl = void 0;
__webpack_require__(5723);
const secrets_1 = __webpack_require__(2022);
const trusted_types_1 = __webpack_require__(5398);
/**
 * Runtime implementation of `TrustedScriptURL` in browsers that don't support
 * it.
 */
class ResourceUrlImpl {
    constructor(url, token) {
        (0, secrets_1.ensureTokenIsValid)(token);
        this.privateDoNotAccessOrElseWrappedResourceUrl = url;
    }
    toString() {
        return this.privateDoNotAccessOrElseWrappedResourceUrl.toString();
    }
}
const GlobalTrustedScriptURL = (typeof window !== 'undefined') ? window.TrustedScriptURL : undefined;
/**
 * Also exports the constructor so that instanceof checks work.
 */
exports.TrustedResourceUrl = (GlobalTrustedScriptURL !== null && GlobalTrustedScriptURL !== void 0 ? GlobalTrustedScriptURL : ResourceUrlImpl);
/**
 * Builds a new `TrustedResourceUrl` from the given string, without
 * enforcing safety guarantees. It may cause side effects by creating a Trusted
 * Types policy. This shouldn't be exposed to application developers, and must
 * only be used as a step towards safe builders or safe constants.
 */
function createResourceUrlInternal(url) {
    var _a;
    /** @noinline */
    const noinlineUrl = url;
    const trustedScriptURL = (_a = (0, trusted_types_1.getTrustedTypesPolicy)()) === null || _a === void 0 ? void 0 : _a.createScriptURL(noinlineUrl);
    return (trustedScriptURL !== null && trustedScriptURL !== void 0 ? trustedScriptURL : new ResourceUrlImpl(noinlineUrl, secrets_1.secretToken));
}
exports.createResourceUrlInternal = createResourceUrlInternal;
/**
 * Checks if the given value is a `TrustedResourceUrl` instance.
 */
function isResourceUrl(value) {
    var _a;
    return ((_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.isScriptURL(value)) ||
        value instanceof ResourceUrlImpl;
}
exports.isResourceUrl = isResourceUrl;
/**
 * Returns the value of the passed `TrustedResourceUrl` object while ensuring it
 * has the correct type.
 *
 * Returns a native `TrustedScriptURL` or a string if Trusted Types are
 * disabled.
 */
function unwrapResourceUrl(value) {
    var _a;
    if ((_a = (0, trusted_types_1.getTrustedTypes)()) === null || _a === void 0 ? void 0 : _a.isScriptURL(value)) {
        return value;
    }
    else if (value instanceof ResourceUrlImpl) {
        return value.privateDoNotAccessOrElseWrappedResourceUrl;
    }
    else {
        let message = '';
        if (false) // removed by dead control flow
{}
        throw new Error(message);
    }
}
exports.unwrapResourceUrl = unwrapResourceUrl;


/***/ },

/***/ 8606
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setHref = void 0;
const resource_url_impl_1 = __webpack_require__(8402);
/**
 * Sets the Href attribute from the given TrustedResourceUrl.
 */
function setHref(baseEl, url) {
    baseEl.href = (0, resource_url_impl_1.unwrapResourceUrl)(url);
}
exports.setHref = setHref;


/***/ },

/***/ 8973
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.safeWorker = exports.safeWindow = exports.safeUrl = exports.safeServiceWorkerContainer = exports.safeRange = exports.safeLocation = exports.safeGlobal = exports.safeDomParser = exports.safeDocument = exports.safeSvgUseEl = exports.safeSvgEl = exports.safeStyleEl = exports.safeScriptEl = exports.safeObjectEl = exports.safeLinkEl = exports.safeInputEl = exports.safeIframeEl = exports.safeFormEl = exports.safeEmbedEl = exports.safeElement = exports.safeButtonEl = exports.safeBaseEl = exports.safeAreaEl = exports.safeAnchorEl = void 0;
/**
 * @fileoverview This file re-exports all of the wrappers to ensure that we have
 * a clearly defined interface.
 */
exports.safeAnchorEl = __importStar(__webpack_require__(7882));
exports.safeAreaEl = __importStar(__webpack_require__(8218));
exports.safeBaseEl = __importStar(__webpack_require__(8606));
exports.safeButtonEl = __importStar(__webpack_require__(3491));
exports.safeElement = __importStar(__webpack_require__(8135));
exports.safeEmbedEl = __importStar(__webpack_require__(9894));
exports.safeFormEl = __importStar(__webpack_require__(249));
exports.safeIframeEl = __importStar(__webpack_require__(6647));
exports.safeInputEl = __importStar(__webpack_require__(4315));
exports.safeLinkEl = __importStar(__webpack_require__(6895));
exports.safeObjectEl = __importStar(__webpack_require__(9916));
exports.safeScriptEl = __importStar(__webpack_require__(832));
exports.safeStyleEl = __importStar(__webpack_require__(5494));
exports.safeSvgEl = __importStar(__webpack_require__(2305));
exports.safeSvgUseEl = __importStar(__webpack_require__(1205));
exports.safeDocument = __importStar(__webpack_require__(7705));
exports.safeDomParser = __importStar(__webpack_require__(4094));
exports.safeGlobal = __importStar(__webpack_require__(2183));
exports.safeLocation = __importStar(__webpack_require__(9651));
exports.safeRange = __importStar(__webpack_require__(247));
exports.safeServiceWorkerContainer = __importStar(__webpack_require__(426));
exports.safeUrl = __importStar(__webpack_require__(2675));
exports.safeWindow = __importStar(__webpack_require__(5000));
exports.safeWorker = __importStar(__webpack_require__(5498));


/***/ },

/***/ 9054
(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.AuthScheme = exports.WazeForms = void 0;
var WazeForms_1 = __webpack_require__(4030);
__createBinding(exports, WazeForms_1, "WazeForms");
__createBinding(exports, WazeForms_1, "AuthScheme");


/***/ },

/***/ 9651
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assign = exports.replace = exports.setHref = void 0;
const url_sanitizer_1 = __webpack_require__(1318);
/**
 * setHref safely sets {@link Location.href} on the given {@link Location} with
 * given {@link Url}.
 */
function setHref(loc, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        loc.href = sanitizedUrl;
    }
}
exports.setHref = setHref;
/**
 * replace safely calls {@link Location.replace} on the given {@link Location}
 * with given {@link Url}.
 */
function replace(loc, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        loc.replace(sanitizedUrl);
    }
}
exports.replace = replace;
/**
 * assign safely calls {@link Location.assign} on the given {@link Location}
 * with given {@link Url}.
 */
function assign(loc, url) {
    const sanitizedUrl = (0, url_sanitizer_1.unwrapUrlOrSanitize)(url);
    if (sanitizedUrl !== undefined) {
        loc.assign(sanitizedUrl);
    }
}
exports.assign = assign;


/***/ },

/***/ 9894
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setSrc = void 0;
const resource_url_impl_1 = __webpack_require__(8402);
/**
 * Sets the Src attribute from the given SafeUrl.
 */
function setSrc(embedEl, url) {
    embedEl.src = (0, resource_url_impl_1.unwrapResourceUrl)(url);
}
exports.setSrc = setSrc;


/***/ },

/***/ 9905
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.joinHtmls = exports.concatHtmls = exports.scriptUrlToHtml = exports.scriptToHtml = exports.htmlEscape = void 0;
const html_impl_1 = __webpack_require__(5971);
const resource_url_impl_1 = __webpack_require__(8402);
const script_impl_1 = __webpack_require__(7253);
/**
 * Returns HTML-escaped text as a `SafeHtml` object. No-op if value is already a
 * SafeHtml instance.
 *
 * Available options:
 * - `preserveSpaces` turns every second consecutive space character into its
 * HTML entity representation (`&#160;`).
 * - `preserveNewlines` turns newline characters into breaks (`<br>`).
 * - `preserveTabs` wraps tab characters in a span with style=white-space:pre.
 */
function htmlEscape(value, options = {}) {
    if ((0, html_impl_1.isHtml)(value)) {
        return value;
    }
    let htmlEscapedString = htmlEscapeToString(String(value));
    if (options.preserveSpaces) {
        // Do this first to ensure we preserve spaces after newlines and tabs.
        htmlEscapedString =
            htmlEscapedString.replace(/(^|[\r\n\t ]) /g, '$1&#160;');
    }
    if (options.preserveNewlines) {
        htmlEscapedString = htmlEscapedString.replace(/(\r\n|\n|\r)/g, '<br>');
    }
    if (options.preserveTabs) {
        htmlEscapedString = htmlEscapedString.replace(/(\t+)/g, '<span style="white-space:pre">$1</span>');
    }
    return (0, html_impl_1.createHtmlInternal)(htmlEscapedString);
}
exports.htmlEscape = htmlEscape;
/**
 * Creates a `SafeHtml` representing a script tag with inline script content.
 */
function scriptToHtml(script, options = {}) {
    const unwrappedScript = (0, script_impl_1.unwrapScript)(script).toString();
    let stringTag = `<script`;
    if (options.id) {
        stringTag += ` id="${htmlEscapeToString(options.id)}"`;
    }
    if (options.nonce) {
        stringTag += ` nonce="${htmlEscapeToString(options.nonce)}"`;
    }
    if (options.type) {
        stringTag += ` type="${htmlEscapeToString(options.type)}"`;
    }
    if (options.defer) {
        stringTag += ` defer`;
    }
    stringTag += `>${unwrappedScript}\u003C/script>`;
    return (0, html_impl_1.createHtmlInternal)(stringTag);
}
exports.scriptToHtml = scriptToHtml;
/**
 * Creates a `SafeHtml` representing a script tag with the src attribute.
 * This also supports CSP nonces and async loading.
 */
function scriptUrlToHtml(src, options = {}) {
    const unwrappedSrc = (0, resource_url_impl_1.unwrapResourceUrl)(src).toString();
    let stringTag = `<script src="${htmlEscapeToString(unwrappedSrc)}"`;
    if (options.async) {
        stringTag += ' async';
    }
    if (options.nonce) {
        stringTag += ` nonce="${htmlEscapeToString(options.nonce)}"`;
    }
    stringTag += '>\u003C/script>';
    return (0, html_impl_1.createHtmlInternal)(stringTag);
}
exports.scriptUrlToHtml = scriptUrlToHtml;
/**
 * HTML-escapes the given text (`&`, `<`, `>`, `"` and `'`).
 */
function htmlEscapeToString(text) {
    const escaped = text.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
    return escaped;
}
/** Creates a `SafeHtml` value by concatenating multiple `SafeHtml`s. */
function concatHtmls(htmls) {
    return joinHtmls('', htmls);
}
exports.concatHtmls = concatHtmls;
/**
 * Creates a `SafeHtml` value by concatenating multiple `SafeHtml`s interleaved
 * with a separator.
 */
function joinHtmls(separator, htmls) {
    const separatorHtml = htmlEscape(separator);
    return (0, html_impl_1.createHtmlInternal)(htmls.map((value) => (0, html_impl_1.unwrapHtml)(htmlEscape(value)))
        .join((0, html_impl_1.unwrapHtml)(separatorHtml).toString()));
}
exports.joinHtmls = joinHtmls;


/***/ },

/***/ 9916
(__unused_webpack_module, exports, __webpack_require__) {


/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setData = void 0;
const resource_url_impl_1 = __webpack_require__(8402);
/** Sets the data attribute using a TrustedResourceUrl */
function setData(obj, v) {
    obj.data = (0, resource_url_impl_1.unwrapResourceUrl)(v);
}
exports.setData = setData;


/***/ }

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "@ember/object"

;// external "discourse/lib/url"

// EXTERNAL MODULE: ../../node_modules/@waze/waze-forms-web-lib/dist/src/index.js
var src = __webpack_require__(9054);
;// external "discourse-i18n"

;// external "../components/waze-copy-logs-button"

;// external "discourse/lib/plugin-api"

;// external "discourse/components/d-navigation"

;// ./src/plugin/assets/javascripts/discourse/initializers/waze-forms-initializer.ts








const WAZE_THEME_ATTRIBUTE = "wz-theme";
const NEW_TOPIC_LABEL_I18N_PREFIX = "js.waze.forms.create_topic_label";
const CUSTOM_FIELDS_KEYS = {
    ENABLED: "custom_fields.enable_waze_forms",
    NEW_TOPIC_LABEL: "custom_fields.waze_forms_new_topic_button_label",
    FORM_ID: "custom_fields.waze_forms_form_id",
    ENABLE_OPEN_LOGS_BUTTON: "custom_fields.enable_open_logs_button",
};
const wazeForms = new src.WazeForms({
    zIndex: "10000",
    // Discourse header zIndex is 1000.
    // The form should be below the header on small screens.
    zIndexSmallScreen: "999",
    addHeaderOffsetSmallScreen: true,
    env: window.location.host.endsWith(".waze.com") ? undefined : "stg",
    submitCallback: (topicId) => {
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_url_7cfbca40_default__.routeTo(`/t/${topicId}`);
        wazeForms.dismissForm();
    },
    cancelCallback: () => {
        // Do nothing.
    },
    closeCallback: () => {
        // Do nothing.
    },
});
function canUserOpenLogs(user, category) {
    var _a;
    if (user == null) {
        return false;
    }
    const userGroupNames = user.groups.map((group) => group.name);
    const allowedGroups = (_a = category.custom_fields) === null || _a === void 0 ? void 0 : _a.groups_allowed_to_open_logs;
    if (allowedGroups) {
        return (allowedGroups
            .split("|")
            .filter((group) => userGroupNames.includes(group)).length > 0);
    }
    return false;
}
function customizePostMenu(api) {
    api.registerValueTransformer("post-menu-buttons", ({ value: dag, context }) => {
        const post = context.post;
        const category = post.topic.category;
        if (category &&
            canUserOpenLogs(api.getCurrentUser(), category) &&
            category.get(CUSTOM_FIELDS_KEYS.ENABLE_OPEN_LOGS_BUTTON) &&
            post.firstPost) {
            dag.add("waze-copy-logs-button", __WEBPACK_EXTERNAL_MODULE__components_waze_copy_logs_button_37428dd1_default__, {
                before: context.firstButtonKey,
            });
        }
    });
}
/* harmony default export */ const waze_forms_initializer = ({
    name: "waze-forms",
    initialize(_container, _app) {
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__("2.1.0", (api) => {
            customizePostMenu(api);
            api.modifyClass("component:category-chooser", {
                pluginId: "waze-forms",
                // Filter the list of categories listed in the categories-chooser in the topic composer,
                // and exclude categories that opted to use waze forms.
                content: __WEBPACK_EXTERNAL_MODULE__ember_object_60179f9a_computed__("selectKit.filter", "selectKit.options.scopedCategoryId", "selectKit.options.prioritizedCategoryId", function () {
                    var _a, _b;
                    const categories = this._super();
                    // Filter categories only in composer
                    if ((_b = (_a = this.parentView) === null || _a === void 0 ? void 0 : _a.classNames) === null || _b === void 0 ? void 0 : _b.includes("d-editor")) {
                        return categories.filter((category) => !category.get(CUSTOM_FIELDS_KEYS.ENABLED));
                    }
                    return categories;
                }),
            });
            __WEBPACK_EXTERNAL_MODULE_discourse_components_d_navigation_29e7ebfd_default__.reopen({
                willRender(...args) {
                    const category = this.category;
                    let formLabelValue = this.createTopicLabel;
                    if (category &&
                        category.get(CUSTOM_FIELDS_KEYS.ENABLED) &&
                        category.get(CUSTOM_FIELDS_KEYS.NEW_TOPIC_LABEL)) {
                        formLabelValue = `${NEW_TOPIC_LABEL_I18N_PREFIX}.${category.get(CUSTOM_FIELDS_KEYS.NEW_TOPIC_LABEL)}`;
                    }
                    document.documentElement.style.setProperty("--waze_forms_new_form_label", `"${__WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_i18n__(formLabelValue)}"`);
                    return this._super(...args);
                },
                // Replace the "New Topic" button behavior, open the form instead of the composer.
                get clickCreateTopicButton() {
                    return (...args) => {
                        if (this.category &&
                            this.category.get(CUSTOM_FIELDS_KEYS.ENABLED)) {
                            wazeForms
                                .startForm({
                                id: this.category.get(CUSTOM_FIELDS_KEYS.FORM_ID),
                                locale: __WEBPACK_EXTERNAL_MODULE_discourse_i18n_c659d411_default__.locale,
                                channel: "web",
                                additionalParams: {
                                    discourseCategorySlug: this.category.slug,
                                    dark: document.documentElement.getAttribute(WAZE_THEME_ATTRIBUTE) === "dark"
                                        ? "1"
                                        : "0",
                                },
                            })
                                .catch(console.error);
                        }
                        else {
                            this.actions.clickCreateTopicButton.bind(this)(...args);
                        }
                    };
                },
            });
        });
    },
});

export { waze_forms_initializer as default };
